
class WebSocketManager {
    constructor() {
        this.socket = null;
        this.connected = false;
        this.requestQueue = new Map();
        this.requestId = 0;
        this.reconnectAttempts = 0;
        this.maxReconnectAttempts = 5;
        this.reconnectDelay = 1000;
        this.hostname = '';
    }

    async connect(wsUrl, hostname) {
        return new Promise((resolve, reject) => {
            try {
                this.socket = new WebSocket(wsUrl);
                this.hostname = hostname;
                
                this.socket.onopen = () => {
                    console.log('WebSocket connecté à', wsUrl);
                    this.connected = true;
                    this.reconnectAttempts = 0;
                    resolve();
                };
                
                this.socket.onmessage = (event) => {
                    try {
                        const response = JSON.parse(event.data);
                        this.handleResponse(response);
                    } catch (error) {
                        console.error('Erreur parsing WebSocket response:', error);
                    }
                };
                
                this.socket.onclose = () => {
                    console.log('WebSocket fermé');
                    this.connected = false;
                    this.attemptReconnect();
                };
                
                this.socket.onerror = (error) => {
                    console.error('Erreur WebSocket:', error);
                    if (!this.connected) {
                        reject(error);
                    }
                };
                
                setTimeout(() => {
                    if (!this.connected) {
                        reject(new Error('Timeout de connexion WebSocket'));
                    }
                }, 10000);
                
            } catch (error) {
                reject(error);
            }
        });
    }
    
    attemptReconnect() {
        if (this.reconnectAttempts >= this.maxReconnectAttempts) {
            console.error('Nombre maximum de tentatives de reconnexion atteint');
            return;
        }
        
        this.reconnectAttempts++;
        console.log(`Tentative de reconnexion ${this.reconnectAttempts}/${this.maxReconnectAttempts}`);
        
        setTimeout(() => {
            this.connect('wss://api.liberium.net/ws', this.hostname)
                .catch(err => console.error('Erreur reconnexion:', err));
        }, this.reconnectDelay * this.reconnectAttempts);
    }
    
    handleResponse(response) {
        const { requestId, status, data, error, headers } = response;
        const pendingRequest = this.requestQueue.get(requestId);
        
        if (pendingRequest) {
            this.requestQueue.delete(requestId);
            
            if (error) {
                pendingRequest.reject(new Error(error));
            } else {
                pendingRequest.resolve({ status, data, headers });
            }
        }
    }
    
    async sendRequest(method, path, options = {}) {
        // Si pas connecté, essayer de se connecter
        if (!this.connected) {
            console.log('WebSocket non connecté, tentative de connexion...');
            try {
                await this.connect('wss://api.liberium.net/ws', this.hostname || 'api.liberium.net');
            } catch (error) {
                throw new Error('Impossible de se connecter au WebSocket: ' + error.message);
            }
        }
        
        // Attendre que la connexion soit vraiment établie (avec timeout)
        const maxWaitTime = 10000; // 10 secondes max
        const startTime = Date.now();
        
        while (!this.connected && (Date.now() - startTime) < maxWaitTime) {
            await new Promise(resolve => setTimeout(resolve, 100)); // Attendre 100ms
        }
        
        if (!this.connected) {
            throw new Error('Timeout: WebSocket non connecté après 10 secondes');
        }
        
        const requestId = ++this.requestId;
        const { body, headers = {}, token } = options;
        
        const requestHeaders = {
            'current-hostname': this.hostname,
            ...headers
        };
        
        if (token) {
            requestHeaders['liberium-token'] = token;
        }
        
        if (body && (typeof body === 'object' || Array.isArray(body))) {
            requestHeaders['Content-Type'] = 'application/json';
        }
        
        const request = {
            requestId,
            method: method.toUpperCase(),
            path,
            headers: requestHeaders,
            body: body && typeof body === 'object' ? JSON.stringify(body) : body
        };
        
        return new Promise((resolve, reject) => {
            this.requestQueue.set(requestId, { resolve, reject });
            
            setTimeout(() => {
                if (this.requestQueue.has(requestId)) {
                    this.requestQueue.delete(requestId);
                    reject(new Error('Timeout de la requête'));
                }
            }, 30000);
            
            this.socket.send(JSON.stringify(request));
        });
    }
}

let wsManager = null;

const initWebSocket = async (isDev = false) => {
    if (!wsManager) {
        wsManager = new WebSocketManager();
    }
    
    if (!wsManager.connected) {
        const hostname = isDev ? 'devapi.liberium.net' : 'api.liberium.net';
        console.log('Connexion WebSocket vers:', hostname);
        await wsManager.connect('wss://api.liberium.net/ws', hostname);
    }
    
    return wsManager;
};
/* sdkWeb.js from models */
var sdk = {};
sdk.models = {};

var model_url = "https://api.liberium.net/models";
//console.log(model_url);

sdk.models.models = {
  createModel: async (model) => {
    try {
      const response = await fetch(model_url + "/models", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(model),
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      return { message: error.message };
    }
  },
  getAllModels: async () => {
    try {
      const response = await fetch(model_url + "/models");
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      return { message: error.message };
    }
  },
  getOne: async (id) => {
    try {
      const response = await fetch(model_url + "/models/" + id);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      return { message: error.message };
    }
  },
  updateModel: async (id, model) => {
    try {
      const response = await fetch(model_url + `/models/${id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(model),
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      return { message: error.message };
    }
  },
  deleteModel: async (id) => {
    try {
      const response = await fetch(model_url + `/models/${id}`, {
        method: "DELETE",
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      return { message: error.message };
    }
  },
  moveToProduction: async (id) => {
    try {
      const response = await fetch(
        model_url + `/models/${id}/moveToProduction`,
        {
          method: "POST",
        }
      );
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      return { message: error.message };
    }
  },
  redeploy: async (id) => {
    try {
      const response = await fetch(
        model_url + `/models/${id}/redeploy`,
        {
          method: "POST",
        }
      );
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      return { message: error.message };
    }
  },
  getBackups: async (id) => {
    try {
      const response = await fetch(model_url + `/backups/model/${id}`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      return { message: error.message };
    }
  },
  createBackup: async (id, description = '') => {
    try {
      const response = await fetch(model_url + `/models/${id}/backup`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ description }),
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      return { message: error.message };
    }
  },
  migrateModel: async (id, targetDatabaseId, environment) => {
    try {
      const response = await fetch(model_url + `/models/${id}/migrate`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ targetDatabaseId, environment }),
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      return { message: error.message };
    }
  },

  // Fonction pour démarrer toutes les instances de développement
  startAllDevInstances: async () => {
    try {
      const response = await fetch(model_url + "/start_all_dev_instances");
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      return { 
        success: false,
        message: error.message 
      };
    }
  },

  // Fonction pour arrêter toutes les instances de développement
  stopAllDevInstances: async () => {
    try {
      const response = await fetch(model_url + "/stop_all_dev_instances");
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      return { 
        success: false,
        message: error.message 
      };
    }
  },
/*
  restoreFromBackup: async (modelId, backupId) => {
    try {
      const response = await fetch(model_url + `/models/${modelId}/restore/${backupId}`, {
        method: "POST",
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      return { message: error.message };
    }
  },
  
  deleteBackup: async (modelId, backupId) => {
    try {
      const response = await fetch(model_url + `/models/${modelId}/backup/${backupId}`, {
        method: "DELETE",
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      return { message: error.message };
    }
  }
*/  
};

sdk.models.hostnames = {
  async getHostnames() {
    const response = await fetch(`${model_url}/hostnames`);
    return await response.json();
  },

  async deploy(id) {
    const response = await fetch(`${model_url}/hostnames/${id}/move-to-production`, {
      method: "POST",
    });
    return await response.json();
  },

  async redeploy(id) {
    const response = await fetch(`${model_url}/hostnames/${id}/redeploy`, {
      method: "POST",
    });
    return await response.json();
  },

  async getHostname(id) {
    const response = await fetch(`${model_url}/hostnames/${id}`);
    return await response.json();
  },

  async updateHostname(id, model) {
    const response = await fetch(`${model_url}/hostnames/${id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(model),
    });
    return await response.json();
  },

  async addHostname(data) {
    const response = await fetch(`${model_url}/hostnames`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    return await response.json();
  },

  async deleteHostname(id) {
    const response = await fetch(`${model_url}/hostnames/${id}`, {
      method: "DELETE",
    });
    return await response.json();
  },

  async deleteHostnameRoute(id, route_id) {
    const response = await fetch(
      `${model_url}/hostnames/${id}/route/${route_id}`,
      {
        method: "DELETE",
      }
    );
    return await response.json();
  },

  async getRoutesByHostname(id) {
    const response = await fetch(`${model_url}/hostnames/${id}/routes`);
    return await response.json();
  },

  async addRouteToHostname(data) {
    const response = await fetch(
      `${model_url}/hostnames/${data.hostnameId}/route`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      }
    );
    return await response.json();
  },

  async rebuild(id) {
    const response = await fetch(
      `${model_url}/hostnames/${id}/rebuild`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({}),
      }
    );
    return await response.json();
  },
};

// Components
sdk.models.components = {
  async getComponents() {
    const response = await fetch(`${model_url}/components`);
    return await response.json();
  },

  async getComponentsUsed() {
    const response = await fetch(`${model_url}/components/used`);
    return await response.json();
  },

  async getComponent(id) {
    const response = await fetch(`${model_url}/components/${id}`);
    return await response.json();
  },

  async updateComponent(id, model) {
    const response = await fetch(`${model_url}/components/${id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(model),
    });
    return await response.json();
  },

  async createComponent(data) {
    const response = await fetch(`${model_url}/components`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    return await response.json();
  },

  async deleteComponent(id) {
    const response = await fetch(`${model_url}/components/${id}`, {
      method: "DELETE",
    });
    return await response.json();
  },
};

// History
sdk.models.history = {
  async getAllHistory() {
    const response = await fetch(`${model_url}/history`);
    return await response.json();
  },

  async getComponentHistory(componentId) {
    const response = await fetch(`${model_url}/history/component/${componentId}`);
    return await response.json();
  },

  async getHistoryById(id) {
    const response = await fetch(`${model_url}/history/${id}`);
    return await response.json();
  },

  async restoreFromHistory(id) {
    const response = await fetch(`${model_url}/history/restore/${id}`, {
      method: "POST",
    });
    return await response.json();
  },

  async deleteHistory(id) {
    const response = await fetch(`${model_url}/history/${id}`, {
      method: "DELETE",
    });
    return await response.json();
  },
};

sdk.models.fields = {
  async getFields(modelId) {
    const response = await fetch(`${model_url}/fields/model/${modelId}`);
    return await response.json();
  },

  async addField(modelId, data) {
    const response = await fetch(`${model_url}/fields`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        ...data, // Ajout des attributs spécifiques
        modelId: modelId,
      }),
    });
    return await response.json();
  },

  async updateField(id, field) {
    const response = await fetch(`${model_url}/fields/${id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(field),
    });
    return await response.json();
  },

  async deleteField(id) {
    const response = await fetch(`${model_url}/fields/${id}`, {
      method: "DELETE",
    });
    return await response.json();
  },
};

sdk.models.functions = {
  async getFunctions(modelId) {
    const response = await fetch(`${model_url}/functions/model/${modelId}`);
    return await response.json();
  },

  async getFunction(id) {
    const response = await fetch(`${model_url}/functions/${id}`);
    return await response.json();
  },

  async addFunction(modelId, data) {
    const response = await fetch(`${model_url}/functions`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        ...data, // Ajout des attributs spécifiques pour les fonctions
        modelId: modelId,
      }),
    });
    return await response.json();
  },

  async updateFunction(modelId, data) {
    const response = await fetch(`${model_url}/functions/${modelId}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        ...data, // Ajout des attributs spécifiques pour les fonctions
        modelId: modelId,
      }),
    });
    return await response.json();
  },

  async deleteFunction(id) {
    const response = await fetch(`${model_url}/functions/${id}`, {
      method: "DELETE",
    });
    return await response.json();
  },
};

sdk.models.databaseHosts = {
  async getDatabaseHosts() {
    const response = await fetch(`${model_url}/database-hosts`);
    return await response.json();
  },

  async deleteDatabaseHost(id) {
    const response = await fetch(`${model_url}/database-hosts/${id}`, {
      method: "DELETE",
    });
    return await response.json();
  },
};


// Helpers
sdk.models.helpers = {
  async getHelpers() {
    const response = await fetch(`${model_url}/helpers`);
    return await response.json();
  },

  async getHelper(id) {
    const response = await fetch(`${model_url}/helpers/${id}`);
    return await response.json();
  },

  async updateHelper(id, model) {
    const response = await fetch(`${model_url}/helpers/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(model),
    });
    return await response.json();
  },

  async createHelper(data) {
    const response = await fetch(`${model_url}/helpers`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
    return await response.json();
  },

  async deleteHelper(id) {
      const response = await fetch(`${model_url}/helpers/${id}`, {
        method: 'DELETE',
      });
      return await response.json();
  },
}
sdk.models.auth = {};

const auth_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur auth_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.auth.create = async (model) => {
    return await auth_fetch('/models/auth', {
        method: 'POST',
        body: model
    });
};

sdk.models.auth.getAll = async () => {
    return await auth_fetch('/models/auth');
};

sdk.models.auth.getOne = async (id) => {
    const cacheKey = "auth_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await auth_fetch('/models/auth/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.auth.update = async (id, model) => {
    localStorage.removeItem("auth_one_" + id);
    return await auth_fetch('/models/auth/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.auth.delete = async (id) => {
    return await auth_fetch('/models/auth/' + id, {
        method: 'DELETE'
    });
};

sdk.models.auth.register = async (data) => {
    return await auth_fetch('/models/auth/register', {
        method: 'POST',
        body: data
    });
};

sdk.models.auth.login = async (data) => {
    return await auth_fetch('/models/auth/login', {
        method: 'POST',
        body: data
    });
};
sdk.models.auth_token = {};

const auth_token_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur auth_token_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.auth_token.create = async (model) => {
    return await auth_token_fetch('/models/auth_token', {
        method: 'POST',
        body: model
    });
};

sdk.models.auth_token.getAll = async () => {
    return await auth_token_fetch('/models/auth_token');
};

sdk.models.auth_token.getOne = async (id) => {
    const cacheKey = "auth_token_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await auth_token_fetch('/models/auth_token/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.auth_token.update = async (id, model) => {
    localStorage.removeItem("auth_token_one_" + id);
    return await auth_token_fetch('/models/auth_token/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.auth_token.delete = async (id) => {
    return await auth_token_fetch('/models/auth_token/' + id, {
        method: 'DELETE'
    });
};

sdk.models.auth_token.getToken = async (data) => {
    return await auth_token_fetch('/models/auth_token/getToken', {
        method: 'POST',
        body: data
    });
};
sdk.models.ville = {};

const ville_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur ville_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.ville.create = async (model) => {
    return await ville_fetch('/models/ville', {
        method: 'POST',
        body: model
    });
};

sdk.models.ville.getAll = async () => {
    return await ville_fetch('/models/ville');
};

sdk.models.ville.getOne = async (id) => {
    const cacheKey = "ville_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await ville_fetch('/models/ville/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.ville.update = async (id, model) => {
    localStorage.removeItem("ville_one_" + id);
    return await ville_fetch('/models/ville/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.ville.delete = async (id) => {
    return await ville_fetch('/models/ville/' + id, {
        method: 'DELETE'
    });
};

sdk.models.ville.import = async (data) => {
    return await ville_fetch('/models/ville/import', {
        method: 'POST',
        body: data
    });
};

sdk.models.ville.getStateCities = async (data) => {
    return await ville_fetch('/models/ville/getStateCities', {
        method: 'POST',
        body: data
    });
};

sdk.models.ville.getCity = async (data) => {
    return await ville_fetch('/models/ville/getCity', {
        method: 'POST',
        body: data
    });
};
sdk.models.post = {};

const post_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur post_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.post.create = async (model) => {
    return await post_fetch('/models/post', {
        method: 'POST',
        body: model
    });
};

sdk.models.post.getAll = async () => {
    return await post_fetch('/models/post');
};

sdk.models.post.getOne = async (id) => {
    const cacheKey = "post_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await post_fetch('/models/post/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.post.update = async (id, model) => {
    localStorage.removeItem("post_one_" + id);
    return await post_fetch('/models/post/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.post.delete = async (id) => {
    return await post_fetch('/models/post/' + id, {
        method: 'DELETE'
    });
};

sdk.models.post.getUserWall = async (data) => {
    return await post_fetch('/models/post/getUserWall', {
        method: 'POST',
        body: data
    });
};

sdk.models.post.getPageWall = async (data) => {
    return await post_fetch('/models/post/getPageWall', {
        method: 'POST',
        body: data
    });
};

sdk.models.post.search = async (data) => {
    return await post_fetch('/models/post/search', {
        method: 'POST',
        body: data
    });
};

sdk.models.post.getVideos = async (data) => {
    return await post_fetch('/models/post/getVideos', {
        method: 'POST',
        body: data
    });
};

sdk.models.post.getUserPosts = async (data) => {
    return await post_fetch('/models/post/getUserPosts', {
        method: 'POST',
        body: data
    });
};

sdk.models.post.onCreate = async (data) => {
    return await post_fetch('/models/post/onCreate', {
        method: 'POST',
        body: data
    });
};

sdk.models.post.getGroupWall = async (data) => {
    return await post_fetch('/models/post/getGroupWall', {
        method: 'POST',
        body: data
    });
};

sdk.models.post.createPagePost = async (data) => {
    return await post_fetch('/models/post/createPagePost', {
        method: 'POST',
        body: data
    });
};

sdk.models.post.createGroupPost = async (data) => {
    return await post_fetch('/models/post/createGroupPost', {
        method: 'POST',
        body: data
    });
};

sdk.models.post.getViralPosts = async (data) => {
    return await post_fetch('/models/post/getViralPosts', {
        method: 'POST',
        body: data
    });
};

sdk.models.post.deletePost = async (data) => {
    return await post_fetch('/models/post/deletePost', {
        method: 'POST',
        body: data
    });
};

sdk.models.post.randomVideo = async (data) => {
    return await post_fetch('/models/post/randomVideo', {
        method: 'POST',
        body: data
    });
};

sdk.models.post.getYoutubeVideo = async (data) => {
    return await post_fetch('/models/post/getYoutubeVideo', {
        method: 'POST',
        body: data
    });
};

sdk.models.post.isYoutubeExist = async (data) => {
    return await post_fetch('/models/post/isYoutubeExist', {
        method: 'POST',
        body: data
    });
};

sdk.models.post.getYoutubePost = async (data) => {
    return await post_fetch('/models/post/getYoutubePost', {
        method: 'POST',
        body: data
    });
};

sdk.models.post.getPost = async (data) => {
    return await post_fetch('/models/post/getPost', {
        method: 'POST',
        body: data
    });
};

sdk.models.post.onNewPost = async (data) => {
    return await post_fetch('/models/post/onNewPost', {
        method: 'POST',
        body: data
    });
};

sdk.models.post.getPageAveragePostByDay = async (data) => {
    return await post_fetch('/models/post/getPageAveragePostByDay', {
        method: 'POST',
        body: data
    });
};

sdk.models.post.increaseShare = async (data) => {
    return await post_fetch('/models/post/increaseShare', {
        method: 'POST',
        body: data
    });
};

sdk.models.post.getLastStats = async (data) => {
    return await post_fetch('/models/post/getLastStats', {
        method: 'POST',
        body: data
    });
};

sdk.models.post.getLastPosts = async (data) => {
    return await post_fetch('/models/post/getLastPosts', {
        method: 'POST',
        body: data
    });
};

sdk.models.post.signal = async (data) => {
    return await post_fetch('/models/post/signal', {
        method: 'POST',
        body: data
    });
};

sdk.models.post.initModel = async (data) => {
    return await post_fetch('/models/post/initModel', {
        method: 'POST',
        body: data
    });
};

sdk.models.post.cleanup = async (data) => {
    return await post_fetch('/models/post/cleanup', {
        method: 'POST',
        body: data
    });
};
sdk.models.SocialPages = {};

const SocialPages_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur SocialPages_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.SocialPages.create = async (model) => {
    return await SocialPages_fetch('/models/SocialPages', {
        method: 'POST',
        body: model
    });
};

sdk.models.SocialPages.getAll = async () => {
    return await SocialPages_fetch('/models/SocialPages');
};

sdk.models.SocialPages.getOne = async (id) => {
    const cacheKey = "SocialPages_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await SocialPages_fetch('/models/SocialPages/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.SocialPages.update = async (id, model) => {
    localStorage.removeItem("SocialPages_one_" + id);
    return await SocialPages_fetch('/models/SocialPages/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.SocialPages.delete = async (id) => {
    return await SocialPages_fetch('/models/SocialPages/' + id, {
        method: 'DELETE'
    });
};

sdk.models.SocialPages.myPages = async (data) => {
    return await SocialPages_fetch('/models/SocialPages/myPages', {
        method: 'POST',
        body: data
    });
};

sdk.models.SocialPages.search = async (data) => {
    return await SocialPages_fetch('/models/SocialPages/search', {
        method: 'POST',
        body: data
    });
};

sdk.models.SocialPages.suggestions = async (data) => {
    return await SocialPages_fetch('/models/SocialPages/suggestions', {
        method: 'POST',
        body: data
    });
};

sdk.models.SocialPages.getBoostedPage = async (data) => {
    return await SocialPages_fetch('/models/SocialPages/getBoostedPage', {
        method: 'POST',
        body: data
    });
};

sdk.models.SocialPages.stats = async (data) => {
    return await SocialPages_fetch('/models/SocialPages/stats', {
        method: 'POST',
        body: data
    });
};

sdk.models.SocialPages.getBalance = async (data) => {
    return await SocialPages_fetch('/models/SocialPages/getBalance', {
        method: 'POST',
        body: data
    });
};

sdk.models.SocialPages.chargePage = async (data) => {
    return await SocialPages_fetch('/models/SocialPages/chargePage', {
        method: 'POST',
        body: data
    });
};
sdk.models.PeupleUser = {};

const PeupleUser_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur PeupleUser_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.PeupleUser.create = async (model) => {
    return await PeupleUser_fetch('/models/PeupleUser', {
        method: 'POST',
        body: model
    });
};

sdk.models.PeupleUser.getAll = async () => {
    return await PeupleUser_fetch('/models/PeupleUser');
};

sdk.models.PeupleUser.getOne = async (id) => {
    const cacheKey = "PeupleUser_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await PeupleUser_fetch('/models/PeupleUser/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.PeupleUser.update = async (id, model) => {
    localStorage.removeItem("PeupleUser_one_" + id);
    return await PeupleUser_fetch('/models/PeupleUser/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.PeupleUser.delete = async (id) => {
    return await PeupleUser_fetch('/models/PeupleUser/' + id, {
        method: 'DELETE'
    });
};

sdk.models.PeupleUser.login = async (data) => {
    return await PeupleUser_fetch('/models/PeupleUser/login', {
        method: 'POST',
        body: data
    });
};

sdk.models.PeupleUser.getMySelf = async (data) => {
    return await PeupleUser_fetch('/models/PeupleUser/getMySelf', {
        method: 'POST',
        body: data
    });
};

sdk.models.PeupleUser.register = async (data) => {
    return await PeupleUser_fetch('/models/PeupleUser/register', {
        method: 'POST',
        body: data
    });
};

sdk.models.PeupleUser.search = async (data) => {
    return await PeupleUser_fetch('/models/PeupleUser/search', {
        method: 'POST',
        body: data
    });
};

sdk.models.PeupleUser.onUpdate = async (data) => {
    return await PeupleUser_fetch('/models/PeupleUser/onUpdate', {
        method: 'POST',
        body: data
    });
};

sdk.models.PeupleUser.getRecoverCode = async (data) => {
    return await PeupleUser_fetch('/models/PeupleUser/getRecoverCode', {
        method: 'POST',
        body: data
    });
};

sdk.models.PeupleUser.changePassword = async (data) => {
    return await PeupleUser_fetch('/models/PeupleUser/changePassword', {
        method: 'POST',
        body: data
    });
};

sdk.models.PeupleUser.getAccountBalance = async (data) => {
    return await PeupleUser_fetch('/models/PeupleUser/getAccountBalance', {
        method: 'POST',
        body: data
    });
};

sdk.models.PeupleUser.upgrade = async (data) => {
    return await PeupleUser_fetch('/models/PeupleUser/upgrade', {
        method: 'POST',
        body: data
    });
};

sdk.models.PeupleUser.getAccount = async (data) => {
    return await PeupleUser_fetch('/models/PeupleUser/getAccount', {
        method: 'POST',
        body: data
    });
};

sdk.models.PeupleUser.getSuggestions = async (data) => {
    return await PeupleUser_fetch('/models/PeupleUser/getSuggestions', {
        method: 'POST',
        body: data
    });
};

sdk.models.PeupleUser.getReferals = async (data) => {
    return await PeupleUser_fetch('/models/PeupleUser/getReferals', {
        method: 'POST',
        body: data
    });
};

sdk.models.PeupleUser.findByEmail = async (data) => {
    return await PeupleUser_fetch('/models/PeupleUser/findByEmail', {
        method: 'POST',
        body: data
    });
};

sdk.models.PeupleUser.getUserAccount = async (data) => {
    return await PeupleUser_fetch('/models/PeupleUser/getUserAccount', {
        method: 'POST',
        body: data
    });
};

sdk.models.PeupleUser.hesOnline = async (data) => {
    return await PeupleUser_fetch('/models/PeupleUser/hesOnline', {
        method: 'POST',
        body: data
    });
};

sdk.models.PeupleUser.getUser = async (data) => {
    return await PeupleUser_fetch('/models/PeupleUser/getUser', {
        method: 'POST',
        body: data
    });
};
sdk.models.SocialNotification = {};

const SocialNotification_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur SocialNotification_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.SocialNotification.create = async (model) => {
    return await SocialNotification_fetch('/models/SocialNotification', {
        method: 'POST',
        body: model
    });
};

sdk.models.SocialNotification.getAll = async () => {
    return await SocialNotification_fetch('/models/SocialNotification');
};

sdk.models.SocialNotification.getOne = async (id) => {
    const cacheKey = "SocialNotification_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await SocialNotification_fetch('/models/SocialNotification/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.SocialNotification.update = async (id, model) => {
    localStorage.removeItem("SocialNotification_one_" + id);
    return await SocialNotification_fetch('/models/SocialNotification/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.SocialNotification.delete = async (id) => {
    return await SocialNotification_fetch('/models/SocialNotification/' + id, {
        method: 'DELETE'
    });
};

sdk.models.SocialNotification.myNotifications = async (data) => {
    return await SocialNotification_fetch('/models/SocialNotification/myNotifications', {
        method: 'POST',
        body: data
    });
};

sdk.models.SocialNotification.onCreate = async (data) => {
    return await SocialNotification_fetch('/models/SocialNotification/onCreate', {
        method: 'POST',
        body: data
    });
};

sdk.models.SocialNotification.initModel = async (data) => {
    return await SocialNotification_fetch('/models/SocialNotification/initModel', {
        method: 'POST',
        body: data
    });
};

sdk.models.SocialNotification.unseenCount = async (data) => {
    return await SocialNotification_fetch('/models/SocialNotification/unseenCount', {
        method: 'POST',
        body: data
    });
};

sdk.models.SocialNotification.markSeen = async (data) => {
    return await SocialNotification_fetch('/models/SocialNotification/markSeen', {
        method: 'POST',
        body: data
    });
};

sdk.models.SocialNotification.setTapped = async (data) => {
    return await SocialNotification_fetch('/models/SocialNotification/setTapped', {
        method: 'POST',
        body: data
    });
};

sdk.models.SocialNotification.getCadeauxStats = async (data) => {
    return await SocialNotification_fetch('/models/SocialNotification/getCadeauxStats', {
        method: 'POST',
        body: data
    });
};

sdk.models.SocialNotification.getUnread = async (data) => {
    return await SocialNotification_fetch('/models/SocialNotification/getUnread', {
        method: 'POST',
        body: data
    });
};
sdk.models.PageLike = {};

const PageLike_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur PageLike_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.PageLike.create = async (model) => {
    return await PageLike_fetch('/models/PageLike', {
        method: 'POST',
        body: model
    });
};

sdk.models.PageLike.getAll = async () => {
    return await PageLike_fetch('/models/PageLike');
};

sdk.models.PageLike.getOne = async (id) => {
    const cacheKey = "PageLike_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await PageLike_fetch('/models/PageLike/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.PageLike.update = async (id, model) => {
    localStorage.removeItem("PageLike_one_" + id);
    return await PageLike_fetch('/models/PageLike/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.PageLike.delete = async (id) => {
    return await PageLike_fetch('/models/PageLike/' + id, {
        method: 'DELETE'
    });
};

sdk.models.PageLike.getUserLikes = async (data) => {
    return await PageLike_fetch('/models/PageLike/getUserLikes', {
        method: 'POST',
        body: data
    });
};

sdk.models.PageLike.getPageLikes = async (data) => {
    return await PageLike_fetch('/models/PageLike/getPageLikes', {
        method: 'POST',
        body: data
    });
};

sdk.models.PageLike.likeCount = async (data) => {
    return await PageLike_fetch('/models/PageLike/likeCount', {
        method: 'POST',
        body: data
    });
};

sdk.models.PageLike.hasLiked = async (data) => {
    return await PageLike_fetch('/models/PageLike/hasLiked', {
        method: 'POST',
        body: data
    });
};

sdk.models.PageLike.onCreate = async (data) => {
    return await PageLike_fetch('/models/PageLike/onCreate', {
        method: 'POST',
        body: data
    });
};
sdk.models.WeeklyContestWinner = {};

const WeeklyContestWinner_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur WeeklyContestWinner_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.WeeklyContestWinner.create = async (model) => {
    return await WeeklyContestWinner_fetch('/models/WeeklyContestWinner', {
        method: 'POST',
        body: model
    });
};

sdk.models.WeeklyContestWinner.getAll = async () => {
    return await WeeklyContestWinner_fetch('/models/WeeklyContestWinner');
};

sdk.models.WeeklyContestWinner.getOne = async (id) => {
    const cacheKey = "WeeklyContestWinner_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await WeeklyContestWinner_fetch('/models/WeeklyContestWinner/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.WeeklyContestWinner.update = async (id, model) => {
    localStorage.removeItem("WeeklyContestWinner_one_" + id);
    return await WeeklyContestWinner_fetch('/models/WeeklyContestWinner/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.WeeklyContestWinner.delete = async (id) => {
    return await WeeklyContestWinner_fetch('/models/WeeklyContestWinner/' + id, {
        method: 'DELETE'
    });
};
sdk.models.ConcoursTicket = {};

const ConcoursTicket_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur ConcoursTicket_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.ConcoursTicket.create = async (model) => {
    return await ConcoursTicket_fetch('/models/ConcoursTicket', {
        method: 'POST',
        body: model
    });
};

sdk.models.ConcoursTicket.getAll = async () => {
    return await ConcoursTicket_fetch('/models/ConcoursTicket');
};

sdk.models.ConcoursTicket.getOne = async (id) => {
    const cacheKey = "ConcoursTicket_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await ConcoursTicket_fetch('/models/ConcoursTicket/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.ConcoursTicket.update = async (id, model) => {
    localStorage.removeItem("ConcoursTicket_one_" + id);
    return await ConcoursTicket_fetch('/models/ConcoursTicket/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.ConcoursTicket.delete = async (id) => {
    return await ConcoursTicket_fetch('/models/ConcoursTicket/' + id, {
        method: 'DELETE'
    });
};

sdk.models.ConcoursTicket.getMyTickets = async (data) => {
    return await ConcoursTicket_fetch('/models/ConcoursTicket/getMyTickets', {
        method: 'POST',
        body: data
    });
};

sdk.models.ConcoursTicket.askAticket = async (data) => {
    return await ConcoursTicket_fetch('/models/ConcoursTicket/askAticket', {
        method: 'POST',
        body: data
    });
};

sdk.models.ConcoursTicket.getTickets = async (data) => {
    return await ConcoursTicket_fetch('/models/ConcoursTicket/getTickets', {
        method: 'POST',
        body: data
    });
};

sdk.models.ConcoursTicket.onCreate = async (data) => {
    return await ConcoursTicket_fetch('/models/ConcoursTicket/onCreate', {
        method: 'POST',
        body: data
    });
};
sdk.models.QuizGame = {};

const QuizGame_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur QuizGame_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.QuizGame.create = async (model) => {
    return await QuizGame_fetch('/models/QuizGame', {
        method: 'POST',
        body: model
    });
};

sdk.models.QuizGame.getAll = async () => {
    return await QuizGame_fetch('/models/QuizGame');
};

sdk.models.QuizGame.getOne = async (id) => {
    const cacheKey = "QuizGame_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await QuizGame_fetch('/models/QuizGame/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.QuizGame.update = async (id, model) => {
    localStorage.removeItem("QuizGame_one_" + id);
    return await QuizGame_fetch('/models/QuizGame/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.QuizGame.delete = async (id) => {
    return await QuizGame_fetch('/models/QuizGame/' + id, {
        method: 'DELETE'
    });
};

sdk.models.QuizGame.onCreate = async (data) => {
    return await QuizGame_fetch('/models/QuizGame/onCreate', {
        method: 'POST',
        body: data
    });
};

sdk.models.QuizGame.upgrade = async (data) => {
    return await QuizGame_fetch('/models/QuizGame/upgrade', {
        method: 'POST',
        body: data
    });
};

sdk.models.QuizGame.getScores = async (data) => {
    return await QuizGame_fetch('/models/QuizGame/getScores', {
        method: 'POST',
        body: data
    });
};
sdk.models.SocialMessage = {};

const SocialMessage_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur SocialMessage_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.SocialMessage.create = async (model) => {
    return await SocialMessage_fetch('/models/SocialMessage', {
        method: 'POST',
        body: model
    });
};

sdk.models.SocialMessage.getAll = async () => {
    return await SocialMessage_fetch('/models/SocialMessage');
};

sdk.models.SocialMessage.getOne = async (id) => {
    const cacheKey = "SocialMessage_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await SocialMessage_fetch('/models/SocialMessage/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.SocialMessage.update = async (id, model) => {
    localStorage.removeItem("SocialMessage_one_" + id);
    return await SocialMessage_fetch('/models/SocialMessage/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.SocialMessage.delete = async (id) => {
    return await SocialMessage_fetch('/models/SocialMessage/' + id, {
        method: 'DELETE'
    });
};

sdk.models.SocialMessage.getDiscussions = async (data) => {
    return await SocialMessage_fetch('/models/SocialMessage/getDiscussions', {
        method: 'POST',
        body: data
    });
};

sdk.models.SocialMessage.getDiscussion = async (data) => {
    return await SocialMessage_fetch('/models/SocialMessage/getDiscussion', {
        method: 'POST',
        body: data
    });
};

sdk.models.SocialMessage.sendMessage = async (data) => {
    return await SocialMessage_fetch('/models/SocialMessage/sendMessage', {
        method: 'POST',
        body: data
    });
};

sdk.models.SocialMessage.setMsgSeen = async (data) => {
    return await SocialMessage_fetch('/models/SocialMessage/setMsgSeen', {
        method: 'POST',
        body: data
    });
};

sdk.models.SocialMessage.countUnread = async (data) => {
    return await SocialMessage_fetch('/models/SocialMessage/countUnread', {
        method: 'POST',
        body: data
    });
};

sdk.models.SocialMessage.getUnreadStats = async (data) => {
    return await SocialMessage_fetch('/models/SocialMessage/getUnreadStats', {
        method: 'POST',
        body: data
    });
};
sdk.models.WeeklyContest = {};

const WeeklyContest_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur WeeklyContest_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.WeeklyContest.create = async (model) => {
    return await WeeklyContest_fetch('/models/WeeklyContest', {
        method: 'POST',
        body: model
    });
};

sdk.models.WeeklyContest.getAll = async () => {
    return await WeeklyContest_fetch('/models/WeeklyContest');
};

sdk.models.WeeklyContest.getOne = async (id) => {
    const cacheKey = "WeeklyContest_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await WeeklyContest_fetch('/models/WeeklyContest/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.WeeklyContest.update = async (id, model) => {
    localStorage.removeItem("WeeklyContest_one_" + id);
    return await WeeklyContest_fetch('/models/WeeklyContest/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.WeeklyContest.delete = async (id) => {
    return await WeeklyContest_fetch('/models/WeeklyContest/' + id, {
        method: 'DELETE'
    });
};
sdk.models.PostsLike = {};

const PostsLike_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur PostsLike_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.PostsLike.create = async (model) => {
    return await PostsLike_fetch('/models/PostsLike', {
        method: 'POST',
        body: model
    });
};

sdk.models.PostsLike.getAll = async () => {
    return await PostsLike_fetch('/models/PostsLike');
};

sdk.models.PostsLike.getOne = async (id) => {
    const cacheKey = "PostsLike_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await PostsLike_fetch('/models/PostsLike/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.PostsLike.update = async (id, model) => {
    localStorage.removeItem("PostsLike_one_" + id);
    return await PostsLike_fetch('/models/PostsLike/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.PostsLike.delete = async (id) => {
    return await PostsLike_fetch('/models/PostsLike/' + id, {
        method: 'DELETE'
    });
};

sdk.models.PostsLike.hasLiked = async (data) => {
    return await PostsLike_fetch('/models/PostsLike/hasLiked', {
        method: 'POST',
        body: data
    });
};

sdk.models.PostsLike.deleteMyLike = async (data) => {
    return await PostsLike_fetch('/models/PostsLike/deleteMyLike', {
        method: 'POST',
        body: data
    });
};

sdk.models.PostsLike.getPostLikes = async (data) => {
    return await PostsLike_fetch('/models/PostsLike/getPostLikes', {
        method: 'POST',
        body: data
    });
};

sdk.models.PostsLike.onCreate = async (data) => {
    return await PostsLike_fetch('/models/PostsLike/onCreate', {
        method: 'POST',
        body: data
    });
};

sdk.models.PostsLike.getUserLikes = async (data) => {
    return await PostsLike_fetch('/models/PostsLike/getUserLikes', {
        method: 'POST',
        body: data
    });
};

sdk.models.PostsLike.getLastHundred = async (data) => {
    return await PostsLike_fetch('/models/PostsLike/getLastHundred', {
        method: 'POST',
        body: data
    });
};

sdk.models.PostsLike.getPostsForGroupUser = async (data) => {
    return await PostsLike_fetch('/models/PostsLike/getPostsForGroupUser', {
        method: 'POST',
        body: data
    });
};
sdk.models.TaskModel = {};

const TaskModel_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur TaskModel_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.TaskModel.create = async (model) => {
    return await TaskModel_fetch('/models/TaskModel', {
        method: 'POST',
        body: model
    });
};

sdk.models.TaskModel.getAll = async () => {
    return await TaskModel_fetch('/models/TaskModel');
};

sdk.models.TaskModel.getOne = async (id) => {
    const cacheKey = "TaskModel_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await TaskModel_fetch('/models/TaskModel/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.TaskModel.update = async (id, model) => {
    localStorage.removeItem("TaskModel_one_" + id);
    return await TaskModel_fetch('/models/TaskModel/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.TaskModel.delete = async (id) => {
    return await TaskModel_fetch('/models/TaskModel/' + id, {
        method: 'DELETE'
    });
};

sdk.models.TaskModel.getModels = async (data) => {
    return await TaskModel_fetch('/models/TaskModel/getModels', {
        method: 'POST',
        body: data
    });
};

sdk.models.TaskModel.updateModel = async (data) => {
    return await TaskModel_fetch('/models/TaskModel/updateModel', {
        method: 'POST',
        body: data
    });
};
sdk.models.UsrMeta = {};

const UsrMeta_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur UsrMeta_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.UsrMeta.create = async (model) => {
    return await UsrMeta_fetch('/models/UsrMeta', {
        method: 'POST',
        body: model
    });
};

sdk.models.UsrMeta.getAll = async () => {
    return await UsrMeta_fetch('/models/UsrMeta');
};

sdk.models.UsrMeta.getOne = async (id) => {
    const cacheKey = "UsrMeta_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await UsrMeta_fetch('/models/UsrMeta/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.UsrMeta.update = async (id, model) => {
    localStorage.removeItem("UsrMeta_one_" + id);
    return await UsrMeta_fetch('/models/UsrMeta/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.UsrMeta.delete = async (id) => {
    return await UsrMeta_fetch('/models/UsrMeta/' + id, {
        method: 'DELETE'
    });
};

sdk.models.UsrMeta.getMyMeta = async (data) => {
    return await UsrMeta_fetch('/models/UsrMeta/getMyMeta', {
        method: 'POST',
        body: data
    });
};

sdk.models.UsrMeta.setMyMeta = async (data) => {
    return await UsrMeta_fetch('/models/UsrMeta/setMyMeta', {
        method: 'POST',
        body: data
    });
};

sdk.models.UsrMeta.getMeta = async (data) => {
    return await UsrMeta_fetch('/models/UsrMeta/getMeta', {
        method: 'POST',
        body: data
    });
};

sdk.models.UsrMeta.doProfil = async (data) => {
    return await UsrMeta_fetch('/models/UsrMeta/doProfil', {
        method: 'POST',
        body: data
    });
};

sdk.models.UsrMeta.setMeta = async (data) => {
    return await UsrMeta_fetch('/models/UsrMeta/setMeta', {
        method: 'POST',
        body: data
    });
};
sdk.models.PostsTime = {};

const PostsTime_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur PostsTime_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.PostsTime.create = async (model) => {
    return await PostsTime_fetch('/models/PostsTime', {
        method: 'POST',
        body: model
    });
};

sdk.models.PostsTime.getAll = async () => {
    return await PostsTime_fetch('/models/PostsTime');
};

sdk.models.PostsTime.getOne = async (id) => {
    const cacheKey = "PostsTime_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await PostsTime_fetch('/models/PostsTime/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.PostsTime.update = async (id, model) => {
    localStorage.removeItem("PostsTime_one_" + id);
    return await PostsTime_fetch('/models/PostsTime/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.PostsTime.delete = async (id) => {
    return await PostsTime_fetch('/models/PostsTime/' + id, {
        method: 'DELETE'
    });
};

sdk.models.PostsTime.getVideosViews = async (data) => {
    return await PostsTime_fetch('/models/PostsTime/getVideosViews', {
        method: 'POST',
        body: data
    });
};

sdk.models.PostsTime.setPostTime = async (data) => {
    return await PostsTime_fetch('/models/PostsTime/setPostTime', {
        method: 'POST',
        body: data
    });
};

sdk.models.PostsTime.onCreate = async (data) => {
    return await PostsTime_fetch('/models/PostsTime/onCreate', {
        method: 'POST',
        body: data
    });
};

sdk.models.PostsTime.getVideoTimes = async (data) => {
    return await PostsTime_fetch('/models/PostsTime/getVideoTimes', {
        method: 'POST',
        body: data
    });
};
sdk.models.Task = {};

const Task_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur Task_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.Task.create = async (model) => {
    return await Task_fetch('/models/Task', {
        method: 'POST',
        body: model
    });
};

sdk.models.Task.getAll = async () => {
    return await Task_fetch('/models/Task');
};

sdk.models.Task.getOne = async (id) => {
    const result = await Task_fetch('/models/Task/' + id);
    return result;
};

sdk.models.Task.update = async (id, model) => {
    return await Task_fetch('/models/Task/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.Task.delete = async (id) => {
    return await Task_fetch('/models/Task/' + id, {
        method: 'DELETE'
    });
};

sdk.models.Task.getTaskAvailable = async (data) => {
    return await Task_fetch('/models/Task/getTaskAvailable', {
        method: 'POST',
        body: data
    });
};

sdk.models.Task.getMyServices = async (data) => {
    return await Task_fetch('/models/Task/getMyServices', {
        method: 'POST',
        body: data
    });
};

sdk.models.Task.getMyTasks = async (data) => {
    return await Task_fetch('/models/Task/getMyTasks', {
        method: 'POST',
        body: data
    });
};

sdk.models.Task.onCreate = async (data) => {
    return await Task_fetch('/models/Task/onCreate', {
        method: 'POST',
        body: data
    });
};

sdk.models.Task.hire = async (data) => {
    return await Task_fetch('/models/Task/hire', {
        method: 'POST',
        body: data
    });
};

sdk.models.Task.completeTask = async (data) => {
    return await Task_fetch('/models/Task/completeTask', {
        method: 'POST',
        body: data
    });
};

sdk.models.Task.createBnb = async (data) => {
    return await Task_fetch('/models/Task/createBnb', {
        method: 'POST',
        body: data
    });
};

sdk.models.Task.createTask = async (data) => {
    return await Task_fetch('/models/Task/createTask', {
        method: 'POST',
        body: data
    });
};

sdk.models.Task.timer = async (data) => {
    return await Task_fetch('/models/Task/timer', {
        method: 'POST',
        body: data
    });
};

sdk.models.Task.yearSummary = async (data) => {
    return await Task_fetch('/models/Task/yearSummary', {
        method: 'POST',
        body: data
    });
};

sdk.models.Task.taskApproved = async (data) => {
    return await Task_fetch('/models/Task/taskApproved', {
        method: 'POST',
        body: data
    });
};

sdk.models.Task.getTask = async (data) => {
    return await Task_fetch('/models/Task/getTask', {
        method: 'POST',
        body: data
    });
};

sdk.models.Task.updateReview = async (data) => {
    return await Task_fetch('/models/Task/updateReview', {
        method: 'POST',
        body: data
    });
};
sdk.models.TaskApply = {};

const TaskApply_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur TaskApply_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.TaskApply.create = async (model) => {
    return await TaskApply_fetch('/models/TaskApply', {
        method: 'POST',
        body: model
    });
};

sdk.models.TaskApply.getAll = async () => {
    return await TaskApply_fetch('/models/TaskApply');
};

sdk.models.TaskApply.getOne = async (id) => {
    const cacheKey = "TaskApply_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await TaskApply_fetch('/models/TaskApply/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.TaskApply.update = async (id, model) => {
    localStorage.removeItem("TaskApply_one_" + id);
    return await TaskApply_fetch('/models/TaskApply/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.TaskApply.delete = async (id) => {
    return await TaskApply_fetch('/models/TaskApply/' + id, {
        method: 'DELETE'
    });
};

sdk.models.TaskApply.hasApplied = async (data) => {
    return await TaskApply_fetch('/models/TaskApply/hasApplied', {
        method: 'POST',
        body: data
    });
};

sdk.models.TaskApply.getAppliers = async (data) => {
    return await TaskApply_fetch('/models/TaskApply/getAppliers', {
        method: 'POST',
        body: data
    });
};

sdk.models.TaskApply.onCreate = async (data) => {
    return await TaskApply_fetch('/models/TaskApply/onCreate', {
        method: 'POST',
        body: data
    });
};
sdk.models.Places = {};

const Places_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur Places_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.Places.create = async (model) => {
    return await Places_fetch('/models/Places', {
        method: 'POST',
        body: model
    });
};

sdk.models.Places.getAll = async () => {
    return await Places_fetch('/models/Places');
};

sdk.models.Places.getOne = async (id) => {
    const cacheKey = "Places_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await Places_fetch('/models/Places/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.Places.update = async (id, model) => {
    localStorage.removeItem("Places_one_" + id);
    return await Places_fetch('/models/Places/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.Places.delete = async (id) => {
    return await Places_fetch('/models/Places/' + id, {
        method: 'DELETE'
    });
};

sdk.models.Places.getNearbyPlaces = async (data) => {
    return await Places_fetch('/models/Places/getNearbyPlaces', {
        method: 'POST',
        body: data
    });
};

sdk.models.Places.getPlace = async (data) => {
    return await Places_fetch('/models/Places/getPlace', {
        method: 'POST',
        body: data
    });
};

sdk.models.Places.getCityPlaces = async (data) => {
    return await Places_fetch('/models/Places/getCityPlaces', {
        method: 'POST',
        body: data
    });
};

sdk.models.Places.import = async (data) => {
    return await Places_fetch('/models/Places/import', {
        method: 'POST',
        body: data
    });
};
sdk.models.TaskUsrModel = {};

const TaskUsrModel_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur TaskUsrModel_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.TaskUsrModel.create = async (model) => {
    return await TaskUsrModel_fetch('/models/TaskUsrModel', {
        method: 'POST',
        body: model
    });
};

sdk.models.TaskUsrModel.getAll = async () => {
    return await TaskUsrModel_fetch('/models/TaskUsrModel');
};

sdk.models.TaskUsrModel.getOne = async (id) => {
    const cacheKey = "TaskUsrModel_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await TaskUsrModel_fetch('/models/TaskUsrModel/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.TaskUsrModel.update = async (id, model) => {
    localStorage.removeItem("TaskUsrModel_one_" + id);
    return await TaskUsrModel_fetch('/models/TaskUsrModel/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.TaskUsrModel.delete = async (id) => {
    return await TaskUsrModel_fetch('/models/TaskUsrModel/' + id, {
        method: 'DELETE'
    });
};

sdk.models.TaskUsrModel.getMyInscriptions = async (data) => {
    return await TaskUsrModel_fetch('/models/TaskUsrModel/getMyInscriptions', {
        method: 'POST',
        body: data
    });
};

sdk.models.TaskUsrModel.createThisModel = async (data) => {
    return await TaskUsrModel_fetch('/models/TaskUsrModel/createThisModel', {
        method: 'POST',
        body: data
    });
};

sdk.models.TaskUsrModel.deleteThisModel = async (data) => {
    return await TaskUsrModel_fetch('/models/TaskUsrModel/deleteThisModel', {
        method: 'POST',
        body: data
    });
};

sdk.models.TaskUsrModel.workersOfModel = async (data) => {
    return await TaskUsrModel_fetch('/models/TaskUsrModel/workersOfModel', {
        method: 'POST',
        body: data
    });
};

sdk.models.TaskUsrModel.getWorkers = async (data) => {
    return await TaskUsrModel_fetch('/models/TaskUsrModel/getWorkers', {
        method: 'POST',
        body: data
    });
};

sdk.models.TaskUsrModel.getUserModels = async (data) => {
    return await TaskUsrModel_fetch('/models/TaskUsrModel/getUserModels', {
        method: 'POST',
        body: data
    });
};

sdk.models.TaskUsrModel.getMapUsers = async (data) => {
    return await TaskUsrModel_fetch('/models/TaskUsrModel/getMapUsers', {
        method: 'POST',
        body: data
    });
};
sdk.models.FcmToken = {};

const FcmToken_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur FcmToken_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.FcmToken.create = async (model) => {
    return await FcmToken_fetch('/models/FcmToken', {
        method: 'POST',
        body: model
    });
};

sdk.models.FcmToken.getAll = async () => {
    return await FcmToken_fetch('/models/FcmToken');
};

sdk.models.FcmToken.getOne = async (id) => {
    const cacheKey = "FcmToken_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await FcmToken_fetch('/models/FcmToken/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.FcmToken.update = async (id, model) => {
    localStorage.removeItem("FcmToken_one_" + id);
    return await FcmToken_fetch('/models/FcmToken/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.FcmToken.delete = async (id) => {
    return await FcmToken_fetch('/models/FcmToken/' + id, {
        method: 'DELETE'
    });
};

sdk.models.FcmToken.getTokensOf = async (data) => {
    return await FcmToken_fetch('/models/FcmToken/getTokensOf', {
        method: 'POST',
        body: data
    });
};
sdk.models.Followers = {};

const Followers_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur Followers_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.Followers.create = async (model) => {
    return await Followers_fetch('/models/Followers', {
        method: 'POST',
        body: model
    });
};

sdk.models.Followers.getAll = async () => {
    return await Followers_fetch('/models/Followers');
};

sdk.models.Followers.getOne = async (id) => {
    const cacheKey = "Followers_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await Followers_fetch('/models/Followers/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.Followers.update = async (id, model) => {
    localStorage.removeItem("Followers_one_" + id);
    return await Followers_fetch('/models/Followers/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.Followers.delete = async (id) => {
    return await Followers_fetch('/models/Followers/' + id, {
        method: 'DELETE'
    });
};

sdk.models.Followers.getFollower = async (data) => {
    return await Followers_fetch('/models/Followers/getFollower', {
        method: 'POST',
        body: data
    });
};

sdk.models.Followers.isFollowing = async (data) => {
    return await Followers_fetch('/models/Followers/isFollowing', {
        method: 'POST',
        body: data
    });
};

sdk.models.Followers.onCreate = async (data) => {
    return await Followers_fetch('/models/Followers/onCreate', {
        method: 'POST',
        body: data
    });
};

sdk.models.Followers.getFollowerOf = async (data) => {
    return await Followers_fetch('/models/Followers/getFollowerOf', {
        method: 'POST',
        body: data
    });
};
sdk.models.SocialComment = {};

const SocialComment_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur SocialComment_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.SocialComment.create = async (model) => {
    return await SocialComment_fetch('/models/SocialComment', {
        method: 'POST',
        body: model
    });
};

sdk.models.SocialComment.getAll = async () => {
    return await SocialComment_fetch('/models/SocialComment');
};

sdk.models.SocialComment.getOne = async (id) => {
    const cacheKey = "SocialComment_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await SocialComment_fetch('/models/SocialComment/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.SocialComment.update = async (id, model) => {
    localStorage.removeItem("SocialComment_one_" + id);
    return await SocialComment_fetch('/models/SocialComment/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.SocialComment.delete = async (id) => {
    return await SocialComment_fetch('/models/SocialComment/' + id, {
        method: 'DELETE'
    });
};

sdk.models.SocialComment.getPostComments = async (data) => {
    return await SocialComment_fetch('/models/SocialComment/getPostComments', {
        method: 'POST',
        body: data
    });
};

sdk.models.SocialComment.onCreate = async (data) => {
    return await SocialComment_fetch('/models/SocialComment/onCreate', {
        method: 'POST',
        body: data
    });
};

sdk.models.SocialComment.getLastHundred = async (data) => {
    return await SocialComment_fetch('/models/SocialComment/getLastHundred', {
        method: 'POST',
        body: data
    });
};

sdk.models.SocialComment.getUserComments = async (data) => {
    return await SocialComment_fetch('/models/SocialComment/getUserComments', {
        method: 'POST',
        body: data
    });
};

sdk.models.SocialComment.beforeCreate = async (data) => {
    return await SocialComment_fetch('/models/SocialComment/beforeCreate', {
        method: 'POST',
        body: data
    });
};

sdk.models.SocialComment.getComment = async (data) => {
    return await SocialComment_fetch('/models/SocialComment/getComment', {
        method: 'POST',
        body: data
    });
};
sdk.models.RefIps = {};

const RefIps_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur RefIps_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.RefIps.create = async (model) => {
    return await RefIps_fetch('/models/RefIps', {
        method: 'POST',
        body: model
    });
};

sdk.models.RefIps.getAll = async () => {
    return await RefIps_fetch('/models/RefIps');
};

sdk.models.RefIps.getOne = async (id) => {
    const cacheKey = "RefIps_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await RefIps_fetch('/models/RefIps/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.RefIps.update = async (id, model) => {
    localStorage.removeItem("RefIps_one_" + id);
    return await RefIps_fetch('/models/RefIps/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.RefIps.delete = async (id) => {
    return await RefIps_fetch('/models/RefIps/' + id, {
        method: 'DELETE'
    });
};

sdk.models.RefIps.findWithIp = async (data) => {
    return await RefIps_fetch('/models/RefIps/findWithIp', {
        method: 'POST',
        body: data
    });
};
sdk.models.UsrAddress = {};

const UsrAddress_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur UsrAddress_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.UsrAddress.create = async (model) => {
    return await UsrAddress_fetch('/models/UsrAddress', {
        method: 'POST',
        body: model
    });
};

sdk.models.UsrAddress.getAll = async () => {
    return await UsrAddress_fetch('/models/UsrAddress');
};

sdk.models.UsrAddress.getOne = async (id) => {
    const cacheKey = "UsrAddress_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await UsrAddress_fetch('/models/UsrAddress/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.UsrAddress.update = async (id, model) => {
    localStorage.removeItem("UsrAddress_one_" + id);
    return await UsrAddress_fetch('/models/UsrAddress/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.UsrAddress.delete = async (id) => {
    return await UsrAddress_fetch('/models/UsrAddress/' + id, {
        method: 'DELETE'
    });
};

sdk.models.UsrAddress.getMyAddress = async (data) => {
    return await UsrAddress_fetch('/models/UsrAddress/getMyAddress', {
        method: 'POST',
        body: data
    });
};

sdk.models.UsrAddress.onCreate = async (data) => {
    return await UsrAddress_fetch('/models/UsrAddress/onCreate', {
        method: 'POST',
        body: data
    });
};

sdk.models.UsrAddress.onUpdate = async (data) => {
    return await UsrAddress_fetch('/models/UsrAddress/onUpdate', {
        method: 'POST',
        body: data
    });
};

sdk.models.UsrAddress.getUserAddress = async (data) => {
    return await UsrAddress_fetch('/models/UsrAddress/getUserAddress', {
        method: 'POST',
        body: data
    });
};
sdk.models.UsrMedia = {};

const UsrMedia_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur UsrMedia_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.UsrMedia.create = async (model) => {
    return await UsrMedia_fetch('/models/UsrMedia', {
        method: 'POST',
        body: model
    });
};

sdk.models.UsrMedia.getAll = async () => {
    return await UsrMedia_fetch('/models/UsrMedia');
};

sdk.models.UsrMedia.getOne = async (id) => {
    const result = await UsrMedia_fetch('/models/UsrMedia/' + id);
    return result;
};

sdk.models.UsrMedia.update = async (id, model) => {
    return await UsrMedia_fetch('/models/UsrMedia/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.UsrMedia.delete = async (id) => {
    return await UsrMedia_fetch('/models/UsrMedia/' + id, {
        method: 'DELETE'
    });
};

sdk.models.UsrMedia.uploadFile = async (data) => {
    return await UsrMedia_fetch('/models/UsrMedia/uploadFile', {
        method: 'POST',
        body: data
    });
};

sdk.models.UsrMedia.onCreate = async (data) => {
    return await UsrMedia_fetch('/models/UsrMedia/onCreate', {
        method: 'POST',
        body: data
    });
};

sdk.models.UsrMedia.uploadAd = async (data) => {
    return await UsrMedia_fetch('/models/UsrMedia/uploadAd', {
        method: 'POST',
        body: data
    });
};

sdk.models.UsrMedia.uploadStorage = async (data) => {
    return await UsrMedia_fetch('/models/UsrMedia/uploadStorage', {
        method: 'POST',
        body: data
    });
};

sdk.models.UsrMedia.uploadItemMedia = async (data) => {
    return await UsrMedia_fetch('/models/UsrMedia/uploadItemMedia', {
        method: 'POST',
        body: data
    });
};

sdk.models.UsrMedia.downloadTo = async (data) => {
    return await UsrMedia_fetch('/models/UsrMedia/downloadTo', {
        method: 'POST',
        body: data
    });
};

sdk.models.UsrMedia.uploadImpot = async (data) => {
    return await UsrMedia_fetch('/models/UsrMedia/uploadImpot', {
        method: 'POST',
        body: data
    });
};

sdk.models.UsrMedia.fileExist = async (data) => {
    return await UsrMedia_fetch('/models/UsrMedia/fileExist', {
        method: 'POST',
        body: data
    });
};

sdk.models.UsrMedia.initModel = async (data) => {
    return await UsrMedia_fetch('/models/UsrMedia/initModel', {
        method: 'POST',
        body: data
    });
};
sdk.models.SocialGroup = {};

const SocialGroup_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur SocialGroup_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.SocialGroup.create = async (model) => {
    return await SocialGroup_fetch('/models/SocialGroup', {
        method: 'POST',
        body: model
    });
};

sdk.models.SocialGroup.getAll = async () => {
    return await SocialGroup_fetch('/models/SocialGroup');
};

sdk.models.SocialGroup.getOne = async (id) => {
    const cacheKey = "SocialGroup_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await SocialGroup_fetch('/models/SocialGroup/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.SocialGroup.update = async (id, model) => {
    localStorage.removeItem("SocialGroup_one_" + id);
    return await SocialGroup_fetch('/models/SocialGroup/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.SocialGroup.delete = async (id) => {
    return await SocialGroup_fetch('/models/SocialGroup/' + id, {
        method: 'DELETE'
    });
};

sdk.models.SocialGroup.myGroups = async (data) => {
    return await SocialGroup_fetch('/models/SocialGroup/myGroups', {
        method: 'POST',
        body: data
    });
};

sdk.models.SocialGroup.search = async (data) => {
    return await SocialGroup_fetch('/models/SocialGroup/search', {
        method: 'POST',
        body: data
    });
};

sdk.models.SocialGroup.onCreate = async (data) => {
    return await SocialGroup_fetch('/models/SocialGroup/onCreate', {
        method: 'POST',
        body: data
    });
};

sdk.models.SocialGroup.suggestions = async (data) => {
    return await SocialGroup_fetch('/models/SocialGroup/suggestions', {
        method: 'POST',
        body: data
    });
};

sdk.models.SocialGroup.ImMembersOf = async (data) => {
    return await SocialGroup_fetch('/models/SocialGroup/ImMembersOf', {
        method: 'POST',
        body: data
    });
};
sdk.models.QuizQuestion = {};

const QuizQuestion_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur QuizQuestion_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.QuizQuestion.create = async (model) => {
    return await QuizQuestion_fetch('/models/QuizQuestion', {
        method: 'POST',
        body: model
    });
};

sdk.models.QuizQuestion.getAll = async () => {
    return await QuizQuestion_fetch('/models/QuizQuestion');
};

sdk.models.QuizQuestion.getOne = async (id) => {
    const cacheKey = "QuizQuestion_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await QuizQuestion_fetch('/models/QuizQuestion/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.QuizQuestion.update = async (id, model) => {
    localStorage.removeItem("QuizQuestion_one_" + id);
    return await QuizQuestion_fetch('/models/QuizQuestion/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.QuizQuestion.delete = async (id) => {
    return await QuizQuestion_fetch('/models/QuizQuestion/' + id, {
        method: 'DELETE'
    });
};

sdk.models.QuizQuestion.import = async (data) => {
    return await QuizQuestion_fetch('/models/QuizQuestion/import', {
        method: 'POST',
        body: data
    });
};

sdk.models.QuizQuestion.getQuestion = async (data) => {
    return await QuizQuestion_fetch('/models/QuizQuestion/getQuestion', {
        method: 'POST',
        body: data
    });
};

sdk.models.QuizQuestion.refresh = async (data) => {
    return await QuizQuestion_fetch('/models/QuizQuestion/refresh', {
        method: 'POST',
        body: data
    });
};
sdk.models.GroupMember = {};

const GroupMember_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur GroupMember_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.GroupMember.create = async (model) => {
    return await GroupMember_fetch('/models/GroupMember', {
        method: 'POST',
        body: model
    });
};

sdk.models.GroupMember.getAll = async () => {
    return await GroupMember_fetch('/models/GroupMember');
};

sdk.models.GroupMember.getOne = async (id) => {
    const cacheKey = "GroupMember_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await GroupMember_fetch('/models/GroupMember/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.GroupMember.update = async (id, model) => {
    localStorage.removeItem("GroupMember_one_" + id);
    return await GroupMember_fetch('/models/GroupMember/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.GroupMember.delete = async (id) => {
    return await GroupMember_fetch('/models/GroupMember/' + id, {
        method: 'DELETE'
    });
};

sdk.models.GroupMember.isMember = async (data) => {
    return await GroupMember_fetch('/models/GroupMember/isMember', {
        method: 'POST',
        body: data
    });
};

sdk.models.GroupMember.getMembersOf = async (data) => {
    return await GroupMember_fetch('/models/GroupMember/getMembersOf', {
        method: 'POST',
        body: data
    });
};

sdk.models.GroupMember.myGroups = async (data) => {
    return await GroupMember_fetch('/models/GroupMember/myGroups', {
        method: 'POST',
        body: data
    });
};

sdk.models.GroupMember.likeCount = async (data) => {
    return await GroupMember_fetch('/models/GroupMember/likeCount', {
        method: 'POST',
        body: data
    });
};

sdk.models.GroupMember.ImMembersOf = async (data) => {
    return await GroupMember_fetch('/models/GroupMember/ImMembersOf', {
        method: 'POST',
        body: data
    });
};
sdk.models.PageCategory = {};

const PageCategory_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur PageCategory_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.PageCategory.create = async (model) => {
    return await PageCategory_fetch('/models/PageCategory', {
        method: 'POST',
        body: model
    });
};

sdk.models.PageCategory.getAll = async () => {
    return await PageCategory_fetch('/models/PageCategory');
};

sdk.models.PageCategory.getOne = async (id) => {
    const cacheKey = "PageCategory_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await PageCategory_fetch('/models/PageCategory/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.PageCategory.update = async (id, model) => {
    localStorage.removeItem("PageCategory_one_" + id);
    return await PageCategory_fetch('/models/PageCategory/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.PageCategory.delete = async (id) => {
    return await PageCategory_fetch('/models/PageCategory/' + id, {
        method: 'DELETE'
    });
};
sdk.models.GroupCategory = {};

const GroupCategory_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur GroupCategory_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.GroupCategory.create = async (model) => {
    return await GroupCategory_fetch('/models/GroupCategory', {
        method: 'POST',
        body: model
    });
};

sdk.models.GroupCategory.getAll = async () => {
    return await GroupCategory_fetch('/models/GroupCategory');
};

sdk.models.GroupCategory.getOne = async (id) => {
    const cacheKey = "GroupCategory_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await GroupCategory_fetch('/models/GroupCategory/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.GroupCategory.update = async (id, model) => {
    localStorage.removeItem("GroupCategory_one_" + id);
    return await GroupCategory_fetch('/models/GroupCategory/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.GroupCategory.delete = async (id) => {
    return await GroupCategory_fetch('/models/GroupCategory/' + id, {
        method: 'DELETE'
    });
};
sdk.models.Logger = {};

const Logger_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur Logger_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.Logger.create = async (model) => {
    return await Logger_fetch('/models/Logger', {
        method: 'POST',
        body: model
    });
};

sdk.models.Logger.getAll = async () => {
    return await Logger_fetch('/models/Logger');
};

sdk.models.Logger.getOne = async (id) => {
    const cacheKey = "Logger_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await Logger_fetch('/models/Logger/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.Logger.update = async (id, model) => {
    localStorage.removeItem("Logger_one_" + id);
    return await Logger_fetch('/models/Logger/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.Logger.delete = async (id) => {
    return await Logger_fetch('/models/Logger/' + id, {
        method: 'DELETE'
    });
};

sdk.models.Logger.getLastLogs = async (data) => {
    return await Logger_fetch('/models/Logger/getLastLogs', {
        method: 'POST',
        body: data
    });
};
sdk.models.AccountingAccount = {};

const AccountingAccount_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur AccountingAccount_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.AccountingAccount.create = async (model) => {
    return await AccountingAccount_fetch('/models/AccountingAccount', {
        method: 'POST',
        body: model
    });
};

sdk.models.AccountingAccount.getAll = async () => {
    return await AccountingAccount_fetch('/models/AccountingAccount');
};

sdk.models.AccountingAccount.getOne = async (id) => {
    const cacheKey = "AccountingAccount_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await AccountingAccount_fetch('/models/AccountingAccount/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.AccountingAccount.update = async (id, model) => {
    localStorage.removeItem("AccountingAccount_one_" + id);
    return await AccountingAccount_fetch('/models/AccountingAccount/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.AccountingAccount.delete = async (id) => {
    return await AccountingAccount_fetch('/models/AccountingAccount/' + id, {
        method: 'DELETE'
    });
};

sdk.models.AccountingAccount.getBalance = async (data) => {
    return await AccountingAccount_fetch('/models/AccountingAccount/getBalance', {
        method: 'POST',
        body: data
    });
};

sdk.models.AccountingAccount.addToBalance = async (data) => {
    return await AccountingAccount_fetch('/models/AccountingAccount/addToBalance', {
        method: 'POST',
        body: data
    });
};

sdk.models.AccountingAccount.getComptes = async (data) => {
    return await AccountingAccount_fetch('/models/AccountingAccount/getComptes', {
        method: 'POST',
        body: data
    });
};

sdk.models.AccountingAccount.updateCompte = async (data) => {
    return await AccountingAccount_fetch('/models/AccountingAccount/updateCompte', {
        method: 'POST',
        body: data
    });
};

sdk.models.AccountingAccount.onUpdate = async (data) => {
    return await AccountingAccount_fetch('/models/AccountingAccount/onUpdate', {
        method: 'POST',
        body: data
    });
};

sdk.models.AccountingAccount.initModel = async (data) => {
    return await AccountingAccount_fetch('/models/AccountingAccount/initModel', {
        method: 'POST',
        body: data
    });
};

sdk.models.AccountingAccount.upgrade = async (data) => {
    return await AccountingAccount_fetch('/models/AccountingAccount/upgrade', {
        method: 'POST',
        body: data
    });
};

sdk.models.AccountingAccount.createCompte = async (data) => {
    return await AccountingAccount_fetch('/models/AccountingAccount/createCompte', {
        method: 'POST',
        body: data
    });
};
sdk.models.EmailMessage = {};

const EmailMessage_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur EmailMessage_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.EmailMessage.create = async (model) => {
    return await EmailMessage_fetch('/models/EmailMessage', {
        method: 'POST',
        body: model
    });
};

sdk.models.EmailMessage.getAll = async () => {
    return await EmailMessage_fetch('/models/EmailMessage');
};

sdk.models.EmailMessage.getOne = async (id) => {
    const cacheKey = "EmailMessage_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await EmailMessage_fetch('/models/EmailMessage/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.EmailMessage.update = async (id, model) => {
    localStorage.removeItem("EmailMessage_one_" + id);
    return await EmailMessage_fetch('/models/EmailMessage/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.EmailMessage.delete = async (id) => {
    return await EmailMessage_fetch('/models/EmailMessage/' + id, {
        method: 'DELETE'
    });
};

sdk.models.EmailMessage.getMsgToSend = async (data) => {
    return await EmailMessage_fetch('/models/EmailMessage/getMsgToSend', {
        method: 'POST',
        body: data
    });
};

sdk.models.EmailMessage.onCreate = async (data) => {
    return await EmailMessage_fetch('/models/EmailMessage/onCreate', {
        method: 'POST',
        body: data
    });
};

sdk.models.EmailMessage.timerDay = async (data) => {
    return await EmailMessage_fetch('/models/EmailMessage/timerDay', {
        method: 'POST',
        body: data
    });
};
sdk.models.ServerHost = {};

const ServerHost_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur ServerHost_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.ServerHost.create = async (model) => {
    return await ServerHost_fetch('/models/ServerHost', {
        method: 'POST',
        body: model
    });
};

sdk.models.ServerHost.getAll = async () => {
    return await ServerHost_fetch('/models/ServerHost');
};

sdk.models.ServerHost.getOne = async (id) => {
    const cacheKey = "ServerHost_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await ServerHost_fetch('/models/ServerHost/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.ServerHost.update = async (id, model) => {
    localStorage.removeItem("ServerHost_one_" + id);
    return await ServerHost_fetch('/models/ServerHost/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.ServerHost.delete = async (id) => {
    return await ServerHost_fetch('/models/ServerHost/' + id, {
        method: 'DELETE'
    });
};
sdk.models.PointsSummary = {};

const PointsSummary_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur PointsSummary_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.PointsSummary.create = async (model) => {
    return await PointsSummary_fetch('/models/PointsSummary', {
        method: 'POST',
        body: model
    });
};

sdk.models.PointsSummary.getAll = async () => {
    return await PointsSummary_fetch('/models/PointsSummary');
};

sdk.models.PointsSummary.getOne = async (id) => {
    const cacheKey = "PointsSummary_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await PointsSummary_fetch('/models/PointsSummary/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.PointsSummary.update = async (id, model) => {
    localStorage.removeItem("PointsSummary_one_" + id);
    return await PointsSummary_fetch('/models/PointsSummary/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.PointsSummary.delete = async (id) => {
    return await PointsSummary_fetch('/models/PointsSummary/' + id, {
        method: 'DELETE'
    });
};

sdk.models.PointsSummary.getMyStats = async (data) => {
    return await PointsSummary_fetch('/models/PointsSummary/getMyStats', {
        method: 'POST',
        body: data
    });
};

sdk.models.PointsSummary.getDay = async (data) => {
    return await PointsSummary_fetch('/models/PointsSummary/getDay', {
        method: 'POST',
        body: data
    });
};
sdk.models.ConcoursGift = {};

const ConcoursGift_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur ConcoursGift_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.ConcoursGift.create = async (model) => {
    return await ConcoursGift_fetch('/models/ConcoursGift', {
        method: 'POST',
        body: model
    });
};

sdk.models.ConcoursGift.getAll = async () => {
    return await ConcoursGift_fetch('/models/ConcoursGift');
};

sdk.models.ConcoursGift.getOne = async (id) => {
    const cacheKey = "ConcoursGift_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await ConcoursGift_fetch('/models/ConcoursGift/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.ConcoursGift.update = async (id, model) => {
    localStorage.removeItem("ConcoursGift_one_" + id);
    return await ConcoursGift_fetch('/models/ConcoursGift/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.ConcoursGift.delete = async (id) => {
    return await ConcoursGift_fetch('/models/ConcoursGift/' + id, {
        method: 'DELETE'
    });
};

sdk.models.ConcoursGift.makeWinner = async (data) => {
    return await ConcoursGift_fetch('/models/ConcoursGift/makeWinner', {
        method: 'POST',
        body: data
    });
};

sdk.models.ConcoursGift.sendMarketing = async (data) => {
    return await ConcoursGift_fetch('/models/ConcoursGift/sendMarketing', {
        method: 'POST',
        body: data
    });
};

sdk.models.ConcoursGift.cronNotification = async (data) => {
    return await ConcoursGift_fetch('/models/ConcoursGift/cronNotification', {
        method: 'POST',
        body: data
    });
};
sdk.models.PostsViews = {};

const PostsViews_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur PostsViews_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.PostsViews.create = async (model) => {
    return await PostsViews_fetch('/models/PostsViews', {
        method: 'POST',
        body: model
    });
};

sdk.models.PostsViews.getAll = async () => {
    return await PostsViews_fetch('/models/PostsViews');
};

sdk.models.PostsViews.getOne = async (id) => {
    const cacheKey = "PostsViews_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await PostsViews_fetch('/models/PostsViews/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.PostsViews.update = async (id, model) => {
    localStorage.removeItem("PostsViews_one_" + id);
    return await PostsViews_fetch('/models/PostsViews/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.PostsViews.delete = async (id) => {
    return await PostsViews_fetch('/models/PostsViews/' + id, {
        method: 'DELETE'
    });
};

sdk.models.PostsViews.addAnonymousView = async (data) => {
    return await PostsViews_fetch('/models/PostsViews/addAnonymousView', {
        method: 'POST',
        body: data
    });
};

sdk.models.PostsViews.onCreate = async (data) => {
    return await PostsViews_fetch('/models/PostsViews/onCreate', {
        method: 'POST',
        body: data
    });
};

sdk.models.PostsViews.getLatestViews = async (data) => {
    return await PostsViews_fetch('/models/PostsViews/getLatestViews', {
        method: 'POST',
        body: data
    });
};

sdk.models.PostsViews.getPostViews = async (data) => {
    return await PostsViews_fetch('/models/PostsViews/getPostViews', {
        method: 'POST',
        body: data
    });
};
sdk.models.GamesPlayed = {};

const GamesPlayed_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur GamesPlayed_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.GamesPlayed.create = async (model) => {
    return await GamesPlayed_fetch('/models/GamesPlayed', {
        method: 'POST',
        body: model
    });
};

sdk.models.GamesPlayed.getAll = async () => {
    return await GamesPlayed_fetch('/models/GamesPlayed');
};

sdk.models.GamesPlayed.getOne = async (id) => {
    const cacheKey = "GamesPlayed_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await GamesPlayed_fetch('/models/GamesPlayed/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.GamesPlayed.update = async (id, model) => {
    localStorage.removeItem("GamesPlayed_one_" + id);
    return await GamesPlayed_fetch('/models/GamesPlayed/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.GamesPlayed.delete = async (id) => {
    return await GamesPlayed_fetch('/models/GamesPlayed/' + id, {
        method: 'DELETE'
    });
};
sdk.models.ServerS3File = {};

const ServerS3File_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur ServerS3File_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.ServerS3File.create = async (model) => {
    return await ServerS3File_fetch('/models/ServerS3File', {
        method: 'POST',
        body: model
    });
};

sdk.models.ServerS3File.getAll = async () => {
    return await ServerS3File_fetch('/models/ServerS3File');
};

sdk.models.ServerS3File.getOne = async (id) => {
    const cacheKey = "ServerS3File_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await ServerS3File_fetch('/models/ServerS3File/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.ServerS3File.update = async (id, model) => {
    localStorage.removeItem("ServerS3File_one_" + id);
    return await ServerS3File_fetch('/models/ServerS3File/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.ServerS3File.delete = async (id) => {
    return await ServerS3File_fetch('/models/ServerS3File/' + id, {
        method: 'DELETE'
    });
};
sdk.models.AdServer = {};

const AdServer_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur AdServer_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.AdServer.create = async (model) => {
    return await AdServer_fetch('/models/AdServer', {
        method: 'POST',
        body: model
    });
};

sdk.models.AdServer.getAll = async () => {
    return await AdServer_fetch('/models/AdServer');
};

sdk.models.AdServer.getOne = async (id) => {
    const cacheKey = "AdServer_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await AdServer_fetch('/models/AdServer/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.AdServer.update = async (id, model) => {
    localStorage.removeItem("AdServer_one_" + id);
    return await AdServer_fetch('/models/AdServer/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.AdServer.delete = async (id) => {
    return await AdServer_fetch('/models/AdServer/' + id, {
        method: 'DELETE'
    });
};

sdk.models.AdServer.selectWallAd = async (data) => {
    return await AdServer_fetch('/models/AdServer/selectWallAd', {
        method: 'POST',
        body: data
    });
};

sdk.models.AdServer.initModel = async (data) => {
    return await AdServer_fetch('/models/AdServer/initModel', {
        method: 'POST',
        body: data
    });
};

sdk.models.AdServer.selectDisplayAd = async (data) => {
    return await AdServer_fetch('/models/AdServer/selectDisplayAd', {
        method: 'POST',
        body: data
    });
};

sdk.models.AdServer.pixelRegister = async (data) => {
    return await AdServer_fetch('/models/AdServer/pixelRegister', {
        method: 'POST',
        body: data
    });
};

sdk.models.AdServer.getInfos = async (data) => {
    return await AdServer_fetch('/models/AdServer/getInfos', {
        method: 'POST',
        body: data
    });
};

sdk.models.AdServer.getVastAd = async (data) => {
    return await AdServer_fetch('/models/AdServer/getVastAd', {
        method: 'POST',
        body: data
    });
};
sdk.models.AdsImpression = {};

const AdsImpression_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur AdsImpression_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.AdsImpression.create = async (model) => {
    return await AdsImpression_fetch('/models/AdsImpression', {
        method: 'POST',
        body: model
    });
};

sdk.models.AdsImpression.getAll = async () => {
    return await AdsImpression_fetch('/models/AdsImpression');
};

sdk.models.AdsImpression.getOne = async (id) => {
    const cacheKey = "AdsImpression_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await AdsImpression_fetch('/models/AdsImpression/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.AdsImpression.update = async (id, model) => {
    localStorage.removeItem("AdsImpression_one_" + id);
    return await AdsImpression_fetch('/models/AdsImpression/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.AdsImpression.delete = async (id) => {
    return await AdsImpression_fetch('/models/AdsImpression/' + id, {
        method: 'DELETE'
    });
};

sdk.models.AdsImpression.addPageImpression = async (data) => {
    return await AdsImpression_fetch('/models/AdsImpression/addPageImpression', {
        method: 'POST',
        body: data
    });
};

sdk.models.AdsImpression.addAdImpression = async (data) => {
    return await AdsImpression_fetch('/models/AdsImpression/addAdImpression', {
        method: 'POST',
        body: data
    });
};

sdk.models.AdsImpression.addNoAd = async (data) => {
    return await AdsImpression_fetch('/models/AdsImpression/addNoAd', {
        method: 'POST',
        body: data
    });
};

sdk.models.AdsImpression.getAdStats = async (data) => {
    return await AdsImpression_fetch('/models/AdsImpression/getAdStats', {
        method: 'POST',
        body: data
    });
};

sdk.models.AdsImpression.getNetworkImpressionStats = async (data) => {
    return await AdsImpression_fetch('/models/AdsImpression/getNetworkImpressionStats', {
        method: 'POST',
        body: data
    });
};

sdk.models.AdsImpression.checkBilling = async (data) => {
    return await AdsImpression_fetch('/models/AdsImpression/checkBilling', {
        method: 'POST',
        body: data
    });
};

sdk.models.AdsImpression.getTodayStats = async (data) => {
    return await AdsImpression_fetch('/models/AdsImpression/getTodayStats', {
        method: 'POST',
        body: data
    });
};

sdk.models.AdsImpression.getDayNetworkImpressions = async (data) => {
    return await AdsImpression_fetch('/models/AdsImpression/getDayNetworkImpressions', {
        method: 'POST',
        body: data
    });
};

sdk.models.AdsImpression.getTodayUsers = async (data) => {
    return await AdsImpression_fetch('/models/AdsImpression/getTodayUsers', {
        method: 'POST',
        body: data
    });
};

sdk.models.AdsImpression.getAudienceStats = async (data) => {
    return await AdsImpression_fetch('/models/AdsImpression/getAudienceStats', {
        method: 'POST',
        body: data
    });
};

sdk.models.AdsImpression.getZoneSubidAmount = async (data) => {
    return await AdsImpression_fetch('/models/AdsImpression/getZoneSubidAmount', {
        method: 'POST',
        body: data
    });
};

sdk.models.AdsImpression.getUserImpressions = async (data) => {
    return await AdsImpression_fetch('/models/AdsImpression/getUserImpressions', {
        method: 'POST',
        body: data
    });
};

sdk.models.AdsImpression.getDayUsersImpressions = async (data) => {
    return await AdsImpression_fetch('/models/AdsImpression/getDayUsersImpressions', {
        method: 'POST',
        body: data
    });
};
sdk.models.AdsClick = {};

const AdsClick_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur AdsClick_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.AdsClick.create = async (model) => {
    return await AdsClick_fetch('/models/AdsClick', {
        method: 'POST',
        body: model
    });
};

sdk.models.AdsClick.getAll = async () => {
    return await AdsClick_fetch('/models/AdsClick');
};

sdk.models.AdsClick.getOne = async (id) => {
    const cacheKey = "AdsClick_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await AdsClick_fetch('/models/AdsClick/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.AdsClick.update = async (id, model) => {
    localStorage.removeItem("AdsClick_one_" + id);
    return await AdsClick_fetch('/models/AdsClick/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.AdsClick.delete = async (id) => {
    return await AdsClick_fetch('/models/AdsClick/' + id, {
        method: 'DELETE'
    });
};

sdk.models.AdsClick.addPageLike = async (data) => {
    return await AdsClick_fetch('/models/AdsClick/addPageLike', {
        method: 'POST',
        body: data
    });
};

sdk.models.AdsClick.addClick = async (data) => {
    return await AdsClick_fetch('/models/AdsClick/addClick', {
        method: 'POST',
        body: data
    });
};

sdk.models.AdsClick.getAdStats = async (data) => {
    return await AdsClick_fetch('/models/AdsClick/getAdStats', {
        method: 'POST',
        body: data
    });
};

sdk.models.AdsClick.getClicksPerIp = async (data) => {
    return await AdsClick_fetch('/models/AdsClick/getClicksPerIp', {
        method: 'POST',
        body: data
    });
};
sdk.models.PostsOverview = {};

const PostsOverview_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur PostsOverview_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.PostsOverview.create = async (model) => {
    return await PostsOverview_fetch('/models/PostsOverview', {
        method: 'POST',
        body: model
    });
};

sdk.models.PostsOverview.getAll = async () => {
    return await PostsOverview_fetch('/models/PostsOverview');
};

sdk.models.PostsOverview.getOne = async (id) => {
    const cacheKey = "PostsOverview_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await PostsOverview_fetch('/models/PostsOverview/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.PostsOverview.update = async (id, model) => {
    localStorage.removeItem("PostsOverview_one_" + id);
    return await PostsOverview_fetch('/models/PostsOverview/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.PostsOverview.delete = async (id) => {
    return await PostsOverview_fetch('/models/PostsOverview/' + id, {
        method: 'DELETE'
    });
};

sdk.models.PostsOverview.getPageStats = async (data) => {
    return await PostsOverview_fetch('/models/PostsOverview/getPageStats', {
        method: 'POST',
        body: data
    });
};

sdk.models.PostsOverview.getDay = async (data) => {
    return await PostsOverview_fetch('/models/PostsOverview/getDay', {
        method: 'POST',
        body: data
    });
};
sdk.models.AdsMedia = {};

const AdsMedia_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur AdsMedia_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.AdsMedia.create = async (model) => {
    return await AdsMedia_fetch('/models/AdsMedia', {
        method: 'POST',
        body: model
    });
};

sdk.models.AdsMedia.getAll = async () => {
    return await AdsMedia_fetch('/models/AdsMedia');
};

sdk.models.AdsMedia.getOne = async (id) => {
    const cacheKey = "AdsMedia_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await AdsMedia_fetch('/models/AdsMedia/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.AdsMedia.update = async (id, model) => {
    localStorage.removeItem("AdsMedia_one_" + id);
    return await AdsMedia_fetch('/models/AdsMedia/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.AdsMedia.delete = async (id) => {
    return await AdsMedia_fetch('/models/AdsMedia/' + id, {
        method: 'DELETE'
    });
};

sdk.models.AdsMedia.getCampMedias = async (data) => {
    return await AdsMedia_fetch('/models/AdsMedia/getCampMedias', {
        method: 'POST',
        body: data
    });
};

sdk.models.AdsMedia.addMedia = async (data) => {
    return await AdsMedia_fetch('/models/AdsMedia/addMedia', {
        method: 'POST',
        body: data
    });
};

sdk.models.AdsMedia.deleteMedia = async (data) => {
    return await AdsMedia_fetch('/models/AdsMedia/deleteMedia', {
        method: 'POST',
        body: data
    });
};
sdk.models.AdsReaction = {};

const AdsReaction_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur AdsReaction_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.AdsReaction.create = async (model) => {
    return await AdsReaction_fetch('/models/AdsReaction', {
        method: 'POST',
        body: model
    });
};

sdk.models.AdsReaction.getAll = async () => {
    return await AdsReaction_fetch('/models/AdsReaction');
};

sdk.models.AdsReaction.getOne = async (id) => {
    const cacheKey = "AdsReaction_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await AdsReaction_fetch('/models/AdsReaction/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.AdsReaction.update = async (id, model) => {
    localStorage.removeItem("AdsReaction_one_" + id);
    return await AdsReaction_fetch('/models/AdsReaction/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.AdsReaction.delete = async (id) => {
    return await AdsReaction_fetch('/models/AdsReaction/' + id, {
        method: 'DELETE'
    });
};

sdk.models.AdsReaction.getAdStats = async (data) => {
    return await AdsReaction_fetch('/models/AdsReaction/getAdStats', {
        method: 'POST',
        body: data
    });
};

sdk.models.AdsReaction.addReaction = async (data) => {
    return await AdsReaction_fetch('/models/AdsReaction/addReaction', {
        method: 'POST',
        body: data
    });
};
sdk.models.FbGroup = {};

const FbGroup_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur FbGroup_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.FbGroup.create = async (model) => {
    return await FbGroup_fetch('/models/FbGroup', {
        method: 'POST',
        body: model
    });
};

sdk.models.FbGroup.getAll = async () => {
    return await FbGroup_fetch('/models/FbGroup');
};

sdk.models.FbGroup.getOne = async (id) => {
    const cacheKey = "FbGroup_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await FbGroup_fetch('/models/FbGroup/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.FbGroup.update = async (id, model) => {
    localStorage.removeItem("FbGroup_one_" + id);
    return await FbGroup_fetch('/models/FbGroup/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.FbGroup.delete = async (id) => {
    return await FbGroup_fetch('/models/FbGroup/' + id, {
        method: 'DELETE'
    });
};

sdk.models.FbGroup.getGroups = async (data) => {
    return await FbGroup_fetch('/models/FbGroup/getGroups', {
        method: 'POST',
        body: data
    });
};

sdk.models.FbGroup.getWorkerUsers = async (data) => {
    return await FbGroup_fetch('/models/FbGroup/getWorkerUsers', {
        method: 'POST',
        body: data
    });
};

sdk.models.FbGroup.getGroupProfiles = async (data) => {
    return await FbGroup_fetch('/models/FbGroup/getGroupProfiles', {
        method: 'POST',
        body: data
    });
};

sdk.models.FbGroup.initModel = async (data) => {
    return await FbGroup_fetch('/models/FbGroup/initModel', {
        method: 'POST',
        body: data
    });
};

sdk.models.FbGroup.search = async (data) => {
    return await FbGroup_fetch('/models/FbGroup/search', {
        method: 'POST',
        body: data
    });
};

sdk.models.FbGroup.checkForTask = async (data) => {
    return await FbGroup_fetch('/models/FbGroup/checkForTask', {
        method: 'POST',
        body: data
    });
};

sdk.models.FbGroup.noPageAllowed = async (data) => {
    return await FbGroup_fetch('/models/FbGroup/noPageAllowed', {
        method: 'POST',
        body: data
    });
};
sdk.models.AdsCampaign = {};

const AdsCampaign_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur AdsCampaign_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.AdsCampaign.create = async (model) => {
    return await AdsCampaign_fetch('/models/AdsCampaign', {
        method: 'POST',
        body: model
    });
};

sdk.models.AdsCampaign.getAll = async () => {
    return await AdsCampaign_fetch('/models/AdsCampaign');
};

sdk.models.AdsCampaign.getOne = async (id) => {
    const cacheKey = "AdsCampaign_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await AdsCampaign_fetch('/models/AdsCampaign/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.AdsCampaign.update = async (id, model) => {
    localStorage.removeItem("AdsCampaign_one_" + id);
    return await AdsCampaign_fetch('/models/AdsCampaign/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.AdsCampaign.delete = async (id) => {
    return await AdsCampaign_fetch('/models/AdsCampaign/' + id, {
        method: 'DELETE'
    });
};

sdk.models.AdsCampaign.getPageAds = async (data) => {
    return await AdsCampaign_fetch('/models/AdsCampaign/getPageAds', {
        method: 'POST',
        body: data
    });
};

sdk.models.AdsCampaign.createPageAd = async (data) => {
    return await AdsCampaign_fetch('/models/AdsCampaign/createPageAd', {
        method: 'POST',
        body: data
    });
};

sdk.models.AdsCampaign.getOneAd = async (data) => {
    return await AdsCampaign_fetch('/models/AdsCampaign/getOneAd', {
        method: 'POST',
        body: data
    });
};

sdk.models.AdsCampaign.updateAd = async (data) => {
    return await AdsCampaign_fetch('/models/AdsCampaign/updateAd', {
        method: 'POST',
        body: data
    });
};

sdk.models.AdsCampaign.getZoneAds = async (data) => {
    return await AdsCampaign_fetch('/models/AdsCampaign/getZoneAds', {
        method: 'POST',
        body: data
    });
};
sdk.models.AccountingTrDetails = {};

const AccountingTrDetails_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur AccountingTrDetails_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.AccountingTrDetails.create = async (model) => {
    return await AccountingTrDetails_fetch('/models/AccountingTrDetails', {
        method: 'POST',
        body: model
    });
};

sdk.models.AccountingTrDetails.getAll = async () => {
    return await AccountingTrDetails_fetch('/models/AccountingTrDetails');
};

sdk.models.AccountingTrDetails.getOne = async (id) => {
    const cacheKey = "AccountingTrDetails_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await AccountingTrDetails_fetch('/models/AccountingTrDetails/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.AccountingTrDetails.update = async (id, model) => {
    localStorage.removeItem("AccountingTrDetails_one_" + id);
    return await AccountingTrDetails_fetch('/models/AccountingTrDetails/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.AccountingTrDetails.delete = async (id) => {
    return await AccountingTrDetails_fetch('/models/AccountingTrDetails/' + id, {
        method: 'DELETE'
    });
};

sdk.models.AccountingTrDetails.onCreate = async (data) => {
    return await AccountingTrDetails_fetch('/models/AccountingTrDetails/onCreate', {
        method: 'POST',
        body: data
    });
};

sdk.models.AccountingTrDetails.getTransactions = async (data) => {
    return await AccountingTrDetails_fetch('/models/AccountingTrDetails/getTransactions', {
        method: 'POST',
        body: data
    });
};
sdk.models.ComponentAccess = {};

const ComponentAccess_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur ComponentAccess_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.ComponentAccess.create = async (model) => {
    return await ComponentAccess_fetch('/models/ComponentAccess', {
        method: 'POST',
        body: model
    });
};

sdk.models.ComponentAccess.getAll = async () => {
    return await ComponentAccess_fetch('/models/ComponentAccess');
};

sdk.models.ComponentAccess.getOne = async (id) => {
    const cacheKey = "ComponentAccess_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await ComponentAccess_fetch('/models/ComponentAccess/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.ComponentAccess.update = async (id, model) => {
    localStorage.removeItem("ComponentAccess_one_" + id);
    return await ComponentAccess_fetch('/models/ComponentAccess/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.ComponentAccess.delete = async (id) => {
    return await ComponentAccess_fetch('/models/ComponentAccess/' + id, {
        method: 'DELETE'
    });
};

sdk.models.ComponentAccess.importEric = async (data) => {
    return await ComponentAccess_fetch('/models/ComponentAccess/importEric', {
        method: 'POST',
        body: data
    });
};

sdk.models.ComponentAccess.createComponent = async (data) => {
    return await ComponentAccess_fetch('/models/ComponentAccess/createComponent', {
        method: 'POST',
        body: data
    });
};

sdk.models.ComponentAccess.updateComponent = async (data) => {
    return await ComponentAccess_fetch('/models/ComponentAccess/updateComponent', {
        method: 'POST',
        body: data
    });
};

sdk.models.ComponentAccess.getMyComponents = async (data) => {
    return await ComponentAccess_fetch('/models/ComponentAccess/getMyComponents', {
        method: 'POST',
        body: data
    });
};
sdk.models.YoutubeVideo = {};

const YoutubeVideo_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur YoutubeVideo_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.YoutubeVideo.create = async (model) => {
    return await YoutubeVideo_fetch('/models/YoutubeVideo', {
        method: 'POST',
        body: model
    });
};

sdk.models.YoutubeVideo.getAll = async () => {
    return await YoutubeVideo_fetch('/models/YoutubeVideo');
};

sdk.models.YoutubeVideo.getOne = async (id) => {
    const cacheKey = "YoutubeVideo_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await YoutubeVideo_fetch('/models/YoutubeVideo/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.YoutubeVideo.update = async (id, model) => {
    localStorage.removeItem("YoutubeVideo_one_" + id);
    return await YoutubeVideo_fetch('/models/YoutubeVideo/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.YoutubeVideo.delete = async (id) => {
    return await YoutubeVideo_fetch('/models/YoutubeVideo/' + id, {
        method: 'DELETE'
    });
};

sdk.models.YoutubeVideo.download = async (data) => {
    return await YoutubeVideo_fetch('/models/YoutubeVideo/download', {
        method: 'POST',
        body: data
    });
};

sdk.models.YoutubeVideo.search = async (data) => {
    return await YoutubeVideo_fetch('/models/YoutubeVideo/search', {
        method: 'POST',
        body: data
    });
};
sdk.models.AccountingTransaction = {};

const AccountingTransaction_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur AccountingTransaction_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.AccountingTransaction.create = async (model) => {
    return await AccountingTransaction_fetch('/models/AccountingTransaction', {
        method: 'POST',
        body: model
    });
};

sdk.models.AccountingTransaction.getAll = async () => {
    return await AccountingTransaction_fetch('/models/AccountingTransaction');
};

sdk.models.AccountingTransaction.getOne = async (id) => {
    const cacheKey = "AccountingTransaction_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await AccountingTransaction_fetch('/models/AccountingTransaction/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.AccountingTransaction.update = async (id, model) => {
    localStorage.removeItem("AccountingTransaction_one_" + id);
    return await AccountingTransaction_fetch('/models/AccountingTransaction/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.AccountingTransaction.delete = async (id) => {
    return await AccountingTransaction_fetch('/models/AccountingTransaction/' + id, {
        method: 'DELETE'
    });
};

sdk.models.AccountingTransaction.newTransaction = async (data) => {
    return await AccountingTransaction_fetch('/models/AccountingTransaction/newTransaction', {
        method: 'POST',
        body: data
    });
};
sdk.models.ScreenDemande = {};

const ScreenDemande_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur ScreenDemande_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.ScreenDemande.create = async (model) => {
    return await ScreenDemande_fetch('/models/ScreenDemande', {
        method: 'POST',
        body: model
    });
};

sdk.models.ScreenDemande.getAll = async () => {
    return await ScreenDemande_fetch('/models/ScreenDemande');
};

sdk.models.ScreenDemande.getOne = async (id) => {
    const cacheKey = "ScreenDemande_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await ScreenDemande_fetch('/models/ScreenDemande/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.ScreenDemande.update = async (id, model) => {
    localStorage.removeItem("ScreenDemande_one_" + id);
    return await ScreenDemande_fetch('/models/ScreenDemande/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.ScreenDemande.delete = async (id) => {
    return await ScreenDemande_fetch('/models/ScreenDemande/' + id, {
        method: 'DELETE'
    });
};

sdk.models.ScreenDemande.getDemandes = async (data) => {
    return await ScreenDemande_fetch('/models/ScreenDemande/getDemandes', {
        method: 'POST',
        body: data
    });
};
sdk.models.PagePaymentCard = {};

const PagePaymentCard_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur PagePaymentCard_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.PagePaymentCard.create = async (model) => {
    return await PagePaymentCard_fetch('/models/PagePaymentCard', {
        method: 'POST',
        body: model
    });
};

sdk.models.PagePaymentCard.getAll = async () => {
    return await PagePaymentCard_fetch('/models/PagePaymentCard');
};

sdk.models.PagePaymentCard.getOne = async (id) => {
    const cacheKey = "PagePaymentCard_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await PagePaymentCard_fetch('/models/PagePaymentCard/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.PagePaymentCard.update = async (id, model) => {
    localStorage.removeItem("PagePaymentCard_one_" + id);
    return await PagePaymentCard_fetch('/models/PagePaymentCard/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.PagePaymentCard.delete = async (id) => {
    return await PagePaymentCard_fetch('/models/PagePaymentCard/' + id, {
        method: 'DELETE'
    });
};

sdk.models.PagePaymentCard.updatePayment = async (data) => {
    return await PagePaymentCard_fetch('/models/PagePaymentCard/updatePayment', {
        method: 'POST',
        body: data
    });
};

sdk.models.PagePaymentCard.hasPayment = async (data) => {
    return await PagePaymentCard_fetch('/models/PagePaymentCard/hasPayment', {
        method: 'POST',
        body: data
    });
};

sdk.models.PagePaymentCard.createPayment = async (data) => {
    return await PagePaymentCard_fetch('/models/PagePaymentCard/createPayment', {
        method: 'POST',
        body: data
    });
};

sdk.models.PagePaymentCard.initModel = async (data) => {
    return await PagePaymentCard_fetch('/models/PagePaymentCard/initModel', {
        method: 'POST',
        body: data
    });
};
sdk.models.AccInvoice = {};

const AccInvoice_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur AccInvoice_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.AccInvoice.create = async (model) => {
    return await AccInvoice_fetch('/models/AccInvoice', {
        method: 'POST',
        body: model
    });
};

sdk.models.AccInvoice.getAll = async () => {
    return await AccInvoice_fetch('/models/AccInvoice');
};

sdk.models.AccInvoice.getOne = async (id) => {
    const cacheKey = "AccInvoice_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await AccInvoice_fetch('/models/AccInvoice/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.AccInvoice.update = async (id, model) => {
    localStorage.removeItem("AccInvoice_one_" + id);
    return await AccInvoice_fetch('/models/AccInvoice/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.AccInvoice.delete = async (id) => {
    return await AccInvoice_fetch('/models/AccInvoice/' + id, {
        method: 'DELETE'
    });
};

sdk.models.AccInvoice.createInvoice = async (data) => {
    return await AccInvoice_fetch('/models/AccInvoice/createInvoice', {
        method: 'POST',
        body: data
    });
};

sdk.models.AccInvoice.doPdf = async (data) => {
    return await AccInvoice_fetch('/models/AccInvoice/doPdf', {
        method: 'POST',
        body: data
    });
};

sdk.models.AccInvoice.beforeCreate = async (data) => {
    return await AccInvoice_fetch('/models/AccInvoice/beforeCreate', {
        method: 'POST',
        body: data
    });
};

sdk.models.AccInvoice.getPageInvoices = async (data) => {
    return await AccInvoice_fetch('/models/AccInvoice/getPageInvoices', {
        method: 'POST',
        body: data
    });
};
sdk.models.Screen = {};

const Screen_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur Screen_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.Screen.create = async (model) => {
    return await Screen_fetch('/models/Screen', {
        method: 'POST',
        body: model
    });
};

sdk.models.Screen.getAll = async () => {
    return await Screen_fetch('/models/Screen');
};

sdk.models.Screen.getOne = async (id) => {
    const cacheKey = "Screen_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await Screen_fetch('/models/Screen/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.Screen.update = async (id, model) => {
    localStorage.removeItem("Screen_one_" + id);
    return await Screen_fetch('/models/Screen/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.Screen.delete = async (id) => {
    return await Screen_fetch('/models/Screen/' + id, {
        method: 'DELETE'
    });
};

sdk.models.Screen.askYoutube = async (data) => {
    return await Screen_fetch('/models/Screen/askYoutube', {
        method: 'POST',
        body: data
    });
};

sdk.models.Screen.updateCurrent = async (data) => {
    return await Screen_fetch('/models/Screen/updateCurrent', {
        method: 'POST',
        body: data
    });
};

sdk.models.Screen.getScreenWithIp = async (data) => {
    return await Screen_fetch('/models/Screen/getScreenWithIp', {
        method: 'POST',
        body: data
    });
};
sdk.models.UsrGpsPosition = {};

const UsrGpsPosition_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur UsrGpsPosition_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.UsrGpsPosition.create = async (model) => {
    return await UsrGpsPosition_fetch('/models/UsrGpsPosition', {
        method: 'POST',
        body: model
    });
};

sdk.models.UsrGpsPosition.getAll = async () => {
    return await UsrGpsPosition_fetch('/models/UsrGpsPosition');
};

sdk.models.UsrGpsPosition.getOne = async (id) => {
    const cacheKey = "UsrGpsPosition_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await UsrGpsPosition_fetch('/models/UsrGpsPosition/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.UsrGpsPosition.update = async (id, model) => {
    localStorage.removeItem("UsrGpsPosition_one_" + id);
    return await UsrGpsPosition_fetch('/models/UsrGpsPosition/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.UsrGpsPosition.delete = async (id) => {
    return await UsrGpsPosition_fetch('/models/UsrGpsPosition/' + id, {
        method: 'DELETE'
    });
};

sdk.models.UsrGpsPosition.beforeCreate = async (data) => {
    return await UsrGpsPosition_fetch('/models/UsrGpsPosition/beforeCreate', {
        method: 'POST',
        body: data
    });
};
sdk.models.ScreenPlayed = {};

const ScreenPlayed_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur ScreenPlayed_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.ScreenPlayed.create = async (model) => {
    return await ScreenPlayed_fetch('/models/ScreenPlayed', {
        method: 'POST',
        body: model
    });
};

sdk.models.ScreenPlayed.getAll = async () => {
    return await ScreenPlayed_fetch('/models/ScreenPlayed');
};

sdk.models.ScreenPlayed.getOne = async (id) => {
    const cacheKey = "ScreenPlayed_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await ScreenPlayed_fetch('/models/ScreenPlayed/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.ScreenPlayed.update = async (id, model) => {
    localStorage.removeItem("ScreenPlayed_one_" + id);
    return await ScreenPlayed_fetch('/models/ScreenPlayed/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.ScreenPlayed.delete = async (id) => {
    return await ScreenPlayed_fetch('/models/ScreenPlayed/' + id, {
        method: 'DELETE'
    });
};

sdk.models.ScreenPlayed.getScreenPlayed = async (data) => {
    return await ScreenPlayed_fetch('/models/ScreenPlayed/getScreenPlayed', {
        method: 'POST',
        body: data
    });
};
sdk.models.ScreenUsers = {};

const ScreenUsers_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur ScreenUsers_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.ScreenUsers.create = async (model) => {
    return await ScreenUsers_fetch('/models/ScreenUsers', {
        method: 'POST',
        body: model
    });
};

sdk.models.ScreenUsers.getAll = async () => {
    return await ScreenUsers_fetch('/models/ScreenUsers');
};

sdk.models.ScreenUsers.getOne = async (id) => {
    const cacheKey = "ScreenUsers_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await ScreenUsers_fetch('/models/ScreenUsers/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.ScreenUsers.update = async (id, model) => {
    localStorage.removeItem("ScreenUsers_one_" + id);
    return await ScreenUsers_fetch('/models/ScreenUsers/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.ScreenUsers.delete = async (id) => {
    return await ScreenUsers_fetch('/models/ScreenUsers/' + id, {
        method: 'DELETE'
    });
};

sdk.models.ScreenUsers.getUsers = async (data) => {
    return await ScreenUsers_fetch('/models/ScreenUsers/getUsers', {
        method: 'POST',
        body: data
    });
};
sdk.models.FbGroupKeywords = {};

const FbGroupKeywords_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur FbGroupKeywords_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.FbGroupKeywords.create = async (model) => {
    return await FbGroupKeywords_fetch('/models/FbGroupKeywords', {
        method: 'POST',
        body: model
    });
};

sdk.models.FbGroupKeywords.getAll = async () => {
    return await FbGroupKeywords_fetch('/models/FbGroupKeywords');
};

sdk.models.FbGroupKeywords.getOne = async (id) => {
    const cacheKey = "FbGroupKeywords_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await FbGroupKeywords_fetch('/models/FbGroupKeywords/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.FbGroupKeywords.update = async (id, model) => {
    localStorage.removeItem("FbGroupKeywords_one_" + id);
    return await FbGroupKeywords_fetch('/models/FbGroupKeywords/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.FbGroupKeywords.delete = async (id) => {
    return await FbGroupKeywords_fetch('/models/FbGroupKeywords/' + id, {
        method: 'DELETE'
    });
};

sdk.models.FbGroupKeywords.getKeywords = async (data) => {
    return await FbGroupKeywords_fetch('/models/FbGroupKeywords/getKeywords', {
        method: 'POST',
        body: data
    });
};
sdk.models.AccInvoiceItem = {};

const AccInvoiceItem_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur AccInvoiceItem_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.AccInvoiceItem.create = async (model) => {
    return await AccInvoiceItem_fetch('/models/AccInvoiceItem', {
        method: 'POST',
        body: model
    });
};

sdk.models.AccInvoiceItem.getAll = async () => {
    return await AccInvoiceItem_fetch('/models/AccInvoiceItem');
};

sdk.models.AccInvoiceItem.getOne = async (id) => {
    const cacheKey = "AccInvoiceItem_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await AccInvoiceItem_fetch('/models/AccInvoiceItem/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.AccInvoiceItem.update = async (id, model) => {
    localStorage.removeItem("AccInvoiceItem_one_" + id);
    return await AccInvoiceItem_fetch('/models/AccInvoiceItem/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.AccInvoiceItem.delete = async (id) => {
    return await AccInvoiceItem_fetch('/models/AccInvoiceItem/' + id, {
        method: 'DELETE'
    });
};

sdk.models.AccInvoiceItem.getItems = async (data) => {
    return await AccInvoiceItem_fetch('/models/AccInvoiceItem/getItems', {
        method: 'POST',
        body: data
    });
};
sdk.models.TaskWaiting = {};

const TaskWaiting_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur TaskWaiting_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.TaskWaiting.create = async (model) => {
    return await TaskWaiting_fetch('/models/TaskWaiting', {
        method: 'POST',
        body: model
    });
};

sdk.models.TaskWaiting.getAll = async () => {
    return await TaskWaiting_fetch('/models/TaskWaiting');
};

sdk.models.TaskWaiting.getOne = async (id) => {
    const cacheKey = "TaskWaiting_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await TaskWaiting_fetch('/models/TaskWaiting/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.TaskWaiting.update = async (id, model) => {
    localStorage.removeItem("TaskWaiting_one_" + id);
    return await TaskWaiting_fetch('/models/TaskWaiting/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.TaskWaiting.delete = async (id) => {
    return await TaskWaiting_fetch('/models/TaskWaiting/' + id, {
        method: 'DELETE'
    });
};

sdk.models.TaskWaiting.getAllWaiting = async (data) => {
    return await TaskWaiting_fetch('/models/TaskWaiting/getAllWaiting', {
        method: 'POST',
        body: data
    });
};

sdk.models.TaskWaiting.redoWaitingTask = async (data) => {
    return await TaskWaiting_fetch('/models/TaskWaiting/redoWaitingTask', {
        method: 'POST',
        body: data
    });
};
sdk.models.PostClick = {};

const PostClick_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur PostClick_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.PostClick.create = async (model) => {
    return await PostClick_fetch('/models/PostClick', {
        method: 'POST',
        body: model
    });
};

sdk.models.PostClick.getAll = async () => {
    return await PostClick_fetch('/models/PostClick');
};

sdk.models.PostClick.getOne = async (id) => {
    const cacheKey = "PostClick_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await PostClick_fetch('/models/PostClick/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.PostClick.update = async (id, model) => {
    localStorage.removeItem("PostClick_one_" + id);
    return await PostClick_fetch('/models/PostClick/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.PostClick.delete = async (id) => {
    return await PostClick_fetch('/models/PostClick/' + id, {
        method: 'DELETE'
    });
};

sdk.models.PostClick.saveClick = async (data) => {
    return await PostClick_fetch('/models/PostClick/saveClick', {
        method: 'POST',
        body: data
    });
};
sdk.models.AdRequest = {};

const AdRequest_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur AdRequest_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.AdRequest.create = async (model) => {
    return await AdRequest_fetch('/models/AdRequest', {
        method: 'POST',
        body: model
    });
};

sdk.models.AdRequest.getAll = async () => {
    return await AdRequest_fetch('/models/AdRequest');
};

sdk.models.AdRequest.getOne = async (id) => {
    const cacheKey = "AdRequest_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await AdRequest_fetch('/models/AdRequest/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.AdRequest.update = async (id, model) => {
    localStorage.removeItem("AdRequest_one_" + id);
    return await AdRequest_fetch('/models/AdRequest/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.AdRequest.delete = async (id) => {
    return await AdRequest_fetch('/models/AdRequest/' + id, {
        method: 'DELETE'
    });
};
sdk.models.CronTask = {};

const CronTask_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur CronTask_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.CronTask.create = async (model) => {
    return await CronTask_fetch('/models/CronTask', {
        method: 'POST',
        body: model
    });
};

sdk.models.CronTask.getAll = async () => {
    return await CronTask_fetch('/models/CronTask');
};

sdk.models.CronTask.getOne = async (id) => {
    const cacheKey = "CronTask_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await CronTask_fetch('/models/CronTask/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.CronTask.update = async (id, model) => {
    localStorage.removeItem("CronTask_one_" + id);
    return await CronTask_fetch('/models/CronTask/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.CronTask.delete = async (id) => {
    return await CronTask_fetch('/models/CronTask/' + id, {
        method: 'DELETE'
    });
};

sdk.models.CronTask.payRef = async (data) => {
    return await CronTask_fetch('/models/CronTask/payRef', {
        method: 'POST',
        body: data
    });
};

sdk.models.CronTask.payPage = async (data) => {
    return await CronTask_fetch('/models/CronTask/payPage', {
        method: 'POST',
        body: data
    });
};

sdk.models.CronTask.checkFacebookData = async (data) => {
    return await CronTask_fetch('/models/CronTask/checkFacebookData', {
        method: 'POST',
        body: data
    });
};

sdk.models.CronTask.dimancheBingo = async (data) => {
    return await CronTask_fetch('/models/CronTask/dimancheBingo', {
        method: 'POST',
        body: data
    });
};
sdk.models.VirtualTask = {};

const VirtualTask_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur VirtualTask_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.VirtualTask.create = async (model) => {
    return await VirtualTask_fetch('/models/VirtualTask', {
        method: 'POST',
        body: model
    });
};

sdk.models.VirtualTask.getAll = async () => {
    return await VirtualTask_fetch('/models/VirtualTask');
};

sdk.models.VirtualTask.getOne = async (id) => {
    const cacheKey = "VirtualTask_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await VirtualTask_fetch('/models/VirtualTask/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.VirtualTask.update = async (id, model) => {
    localStorage.removeItem("VirtualTask_one_" + id);
    return await VirtualTask_fetch('/models/VirtualTask/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.VirtualTask.delete = async (id) => {
    return await VirtualTask_fetch('/models/VirtualTask/' + id, {
        method: 'DELETE'
    });
};

sdk.models.VirtualTask.getTask = async (data) => {
    return await VirtualTask_fetch('/models/VirtualTask/getTask', {
        method: 'POST',
        body: data
    });
};

sdk.models.VirtualTask.answer = async (data) => {
    return await VirtualTask_fetch('/models/VirtualTask/answer', {
        method: 'POST',
        body: data
    });
};

sdk.models.VirtualTask.getFbPostStats = async (data) => {
    return await VirtualTask_fetch('/models/VirtualTask/getFbPostStats', {
        method: 'POST',
        body: data
    });
};

sdk.models.VirtualTask.initModel = async (data) => {
    return await VirtualTask_fetch('/models/VirtualTask/initModel', {
        method: 'POST',
        body: data
    });
};

sdk.models.VirtualTask.getWorkerStats = async (data) => {
    return await VirtualTask_fetch('/models/VirtualTask/getWorkerStats', {
        method: 'POST',
        body: data
    });
};

sdk.models.VirtualTask.countTask = async (data) => {
    return await VirtualTask_fetch('/models/VirtualTask/countTask', {
        method: 'POST',
        body: data
    });
};

sdk.models.VirtualTask.doPayment = async (data) => {
    return await VirtualTask_fetch('/models/VirtualTask/doPayment', {
        method: 'POST',
        body: data
    });
};
sdk.models.MarketItem = {};

const MarketItem_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur MarketItem_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.MarketItem.create = async (model) => {
    return await MarketItem_fetch('/models/MarketItem', {
        method: 'POST',
        body: model
    });
};

sdk.models.MarketItem.getAll = async () => {
    return await MarketItem_fetch('/models/MarketItem');
};

sdk.models.MarketItem.getOne = async (id) => {
    const cacheKey = "MarketItem_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await MarketItem_fetch('/models/MarketItem/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.MarketItem.update = async (id, model) => {
    localStorage.removeItem("MarketItem_one_" + id);
    return await MarketItem_fetch('/models/MarketItem/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.MarketItem.delete = async (id) => {
    return await MarketItem_fetch('/models/MarketItem/' + id, {
        method: 'DELETE'
    });
};

sdk.models.MarketItem.getByShopItemId = async (data) => {
    return await MarketItem_fetch('/models/MarketItem/getByShopItemId', {
        method: 'POST',
        body: data
    });
};
sdk.models.Points = {};

const Points_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur Points_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.Points.create = async (model) => {
    return await Points_fetch('/models/Points', {
        method: 'POST',
        body: model
    });
};

sdk.models.Points.getAll = async () => {
    return await Points_fetch('/models/Points');
};

sdk.models.Points.getOne = async (id) => {
    const cacheKey = "Points_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await Points_fetch('/models/Points/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.Points.update = async (id, model) => {
    localStorage.removeItem("Points_one_" + id);
    return await Points_fetch('/models/Points/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.Points.delete = async (id) => {
    return await Points_fetch('/models/Points/' + id, {
        method: 'DELETE'
    });
};

sdk.models.Points.getPointsOfDay = async (data) => {
    return await Points_fetch('/models/Points/getPointsOfDay', {
        method: 'POST',
        body: data
    });
};
sdk.models.Client = {};

const Client_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur Client_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.Client.create = async (model) => {
    return await Client_fetch('/models/Client', {
        method: 'POST',
        body: model
    });
};

sdk.models.Client.getAll = async () => {
    return await Client_fetch('/models/Client');
};

sdk.models.Client.getOne = async (id) => {
    const cacheKey = "Client_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await Client_fetch('/models/Client/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.Client.update = async (id, model) => {
    localStorage.removeItem("Client_one_" + id);
    return await Client_fetch('/models/Client/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.Client.delete = async (id) => {
    return await Client_fetch('/models/Client/' + id, {
        method: 'DELETE'
    });
};

sdk.models.Client.getClient = async (data) => {
    return await Client_fetch('/models/Client/getClient', {
        method: 'POST',
        body: data
    });
};

sdk.models.Client.updateClient = async (data) => {
    return await Client_fetch('/models/Client/updateClient', {
        method: 'POST',
        body: data
    });
};

sdk.models.Client.getMr69Pdf = async (data) => {
    return await Client_fetch('/models/Client/getMr69Pdf', {
        method: 'POST',
        body: data
    });
};
sdk.models.Link = {};

const Link_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur Link_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.Link.create = async (model) => {
    return await Link_fetch('/models/Link', {
        method: 'POST',
        body: model
    });
};

sdk.models.Link.getAll = async () => {
    return await Link_fetch('/models/Link');
};

sdk.models.Link.getOne = async (id) => {
    const cacheKey = "Link_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await Link_fetch('/models/Link/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.Link.update = async (id, model) => {
    localStorage.removeItem("Link_one_" + id);
    return await Link_fetch('/models/Link/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.Link.delete = async (id) => {
    return await Link_fetch('/models/Link/' + id, {
        method: 'DELETE'
    });
};

sdk.models.Link.onCreate = async (data) => {
    return await Link_fetch('/models/Link/onCreate', {
        method: 'POST',
        body: data
    });
};

sdk.models.Link.getLatestPosts = async (data) => {
    return await Link_fetch('/models/Link/getLatestPosts', {
        method: 'POST',
        body: data
    });
};
sdk.models.LinkClick = {};

const LinkClick_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur LinkClick_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.LinkClick.create = async (model) => {
    return await LinkClick_fetch('/models/LinkClick', {
        method: 'POST',
        body: model
    });
};

sdk.models.LinkClick.getAll = async () => {
    return await LinkClick_fetch('/models/LinkClick');
};

sdk.models.LinkClick.getOne = async (id) => {
    const cacheKey = "LinkClick_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await LinkClick_fetch('/models/LinkClick/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.LinkClick.update = async (id, model) => {
    localStorage.removeItem("LinkClick_one_" + id);
    return await LinkClick_fetch('/models/LinkClick/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.LinkClick.delete = async (id) => {
    return await LinkClick_fetch('/models/LinkClick/' + id, {
        method: 'DELETE'
    });
};

sdk.models.LinkClick.addClickLink = async (data) => {
    return await LinkClick_fetch('/models/LinkClick/addClickLink', {
        method: 'POST',
        body: data
    });
};

sdk.models.LinkClick.calculateClicks = async (data) => {
    return await LinkClick_fetch('/models/LinkClick/calculateClicks', {
        method: 'POST',
        body: data
    });
};
sdk.models.Crawler = {};

const Crawler_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur Crawler_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.Crawler.create = async (model) => {
    return await Crawler_fetch('/models/Crawler', {
        method: 'POST',
        body: model
    });
};

sdk.models.Crawler.getAll = async () => {
    return await Crawler_fetch('/models/Crawler');
};

sdk.models.Crawler.getOne = async (id) => {
    const cacheKey = "Crawler_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await Crawler_fetch('/models/Crawler/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.Crawler.update = async (id, model) => {
    localStorage.removeItem("Crawler_one_" + id);
    return await Crawler_fetch('/models/Crawler/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.Crawler.delete = async (id) => {
    return await Crawler_fetch('/models/Crawler/' + id, {
        method: 'DELETE'
    });
};

sdk.models.Crawler.doGervaisUrl = async (data) => {
    return await Crawler_fetch('/models/Crawler/doGervaisUrl', {
        method: 'POST',
        body: data
    });
};

sdk.models.Crawler.doUrl = async (data) => {
    return await Crawler_fetch('/models/Crawler/doUrl', {
        method: 'POST',
        body: data
    });
};

sdk.models.Crawler.doCossetteUrl = async (data) => {
    return await Crawler_fetch('/models/Crawler/doCossetteUrl', {
        method: 'POST',
        body: data
    });
};

sdk.models.Crawler.searchGoogle = async (data) => {
    return await Crawler_fetch('/models/Crawler/searchGoogle', {
        method: 'POST',
        body: data
    });
};

sdk.models.Crawler.getEmails = async (data) => {
    return await Crawler_fetch('/models/Crawler/getEmails', {
        method: 'POST',
        body: data
    });
};
sdk.models.StorageItem = {};

const StorageItem_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur StorageItem_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.StorageItem.create = async (model) => {
    return await StorageItem_fetch('/models/StorageItem', {
        method: 'POST',
        body: model
    });
};

sdk.models.StorageItem.getAll = async () => {
    return await StorageItem_fetch('/models/StorageItem');
};

sdk.models.StorageItem.getOne = async (id) => {
    const cacheKey = "StorageItem_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await StorageItem_fetch('/models/StorageItem/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.StorageItem.update = async (id, model) => {
    localStorage.removeItem("StorageItem_one_" + id);
    return await StorageItem_fetch('/models/StorageItem/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.StorageItem.delete = async (id) => {
    return await StorageItem_fetch('/models/StorageItem/' + id, {
        method: 'DELETE'
    });
};

sdk.models.StorageItem.getMyItems = async (data) => {
    return await StorageItem_fetch('/models/StorageItem/getMyItems', {
        method: 'POST',
        body: data
    });
};
sdk.models.StorItem = {};

const StorItem_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur StorItem_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.StorItem.create = async (model) => {
    return await StorItem_fetch('/models/StorItem', {
        method: 'POST',
        body: model
    });
};

sdk.models.StorItem.getAll = async () => {
    return await StorItem_fetch('/models/StorItem');
};

sdk.models.StorItem.getOne = async (id) => {
    const cacheKey = "StorItem_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await StorItem_fetch('/models/StorItem/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.StorItem.update = async (id, model) => {
    localStorage.removeItem("StorItem_one_" + id);
    return await StorItem_fetch('/models/StorItem/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.StorItem.delete = async (id) => {
    return await StorItem_fetch('/models/StorItem/' + id, {
        method: 'DELETE'
    });
};

sdk.models.StorItem.getPageItems = async (data) => {
    return await StorItem_fetch('/models/StorItem/getPageItems', {
        method: 'POST',
        body: data
    });
};

sdk.models.StorItem.getPageItem = async (data) => {
    return await StorItem_fetch('/models/StorItem/getPageItem', {
        method: 'POST',
        body: data
    });
};

sdk.models.StorItem.searchItems = async (data) => {
    return await StorItem_fetch('/models/StorItem/searchItems', {
        method: 'POST',
        body: data
    });
};
sdk.models.ShopCategory = {};

const ShopCategory_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur ShopCategory_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.ShopCategory.create = async (model) => {
    return await ShopCategory_fetch('/models/ShopCategory', {
        method: 'POST',
        body: model
    });
};

sdk.models.ShopCategory.getAll = async () => {
    return await ShopCategory_fetch('/models/ShopCategory');
};

sdk.models.ShopCategory.getOne = async (id) => {
    const cacheKey = "ShopCategory_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await ShopCategory_fetch('/models/ShopCategory/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.ShopCategory.update = async (id, model) => {
    localStorage.removeItem("ShopCategory_one_" + id);
    return await ShopCategory_fetch('/models/ShopCategory/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.ShopCategory.delete = async (id) => {
    return await ShopCategory_fetch('/models/ShopCategory/' + id, {
        method: 'DELETE'
    });
};
sdk.models.StorageBox = {};

const StorageBox_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur StorageBox_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.StorageBox.create = async (model) => {
    return await StorageBox_fetch('/models/StorageBox', {
        method: 'POST',
        body: model
    });
};

sdk.models.StorageBox.getAll = async () => {
    return await StorageBox_fetch('/models/StorageBox');
};

sdk.models.StorageBox.getOne = async (id) => {
    const cacheKey = "StorageBox_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await StorageBox_fetch('/models/StorageBox/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.StorageBox.update = async (id, model) => {
    localStorage.removeItem("StorageBox_one_" + id);
    return await StorageBox_fetch('/models/StorageBox/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.StorageBox.delete = async (id) => {
    return await StorageBox_fetch('/models/StorageBox/' + id, {
        method: 'DELETE'
    });
};

sdk.models.StorageBox.getMyBoxes = async (data) => {
    return await StorageBox_fetch('/models/StorageBox/getMyBoxes', {
        method: 'POST',
        body: data
    });
};

sdk.models.StorageBox.getPageBoxes = async (data) => {
    return await StorageBox_fetch('/models/StorageBox/getPageBoxes', {
        method: 'POST',
        body: data
    });
};

sdk.models.StorageBox.createPageBox = async (data) => {
    return await StorageBox_fetch('/models/StorageBox/createPageBox', {
        method: 'POST',
        body: data
    });
};

sdk.models.StorageBox.getPageAvailable = async (data) => {
    return await StorageBox_fetch('/models/StorageBox/getPageAvailable', {
        method: 'POST',
        body: data
    });
};

sdk.models.StorageBox.getBoxForWorker = async (data) => {
    return await StorageBox_fetch('/models/StorageBox/getBoxForWorker', {
        method: 'POST',
        body: data
    });
};
sdk.models.ShopTransfer = {};

const ShopTransfer_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur ShopTransfer_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.ShopTransfer.create = async (model) => {
    return await ShopTransfer_fetch('/models/ShopTransfer', {
        method: 'POST',
        body: model
    });
};

sdk.models.ShopTransfer.getAll = async () => {
    return await ShopTransfer_fetch('/models/ShopTransfer');
};

sdk.models.ShopTransfer.getOne = async (id) => {
    const cacheKey = "ShopTransfer_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await ShopTransfer_fetch('/models/ShopTransfer/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.ShopTransfer.update = async (id, model) => {
    localStorage.removeItem("ShopTransfer_one_" + id);
    return await ShopTransfer_fetch('/models/ShopTransfer/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.ShopTransfer.delete = async (id) => {
    return await ShopTransfer_fetch('/models/ShopTransfer/' + id, {
        method: 'DELETE'
    });
};

sdk.models.ShopTransfer.getCurrentTransfert = async (data) => {
    return await ShopTransfer_fetch('/models/ShopTransfer/getCurrentTransfert', {
        method: 'POST',
        body: data
    });
};

sdk.models.ShopTransfer.executeOrder = async (data) => {
    return await ShopTransfer_fetch('/models/ShopTransfer/executeOrder', {
        method: 'POST',
        body: data
    });
};

sdk.models.ShopTransfer.getTransfer = async (data) => {
    return await ShopTransfer_fetch('/models/ShopTransfer/getTransfer', {
        method: 'POST',
        body: data
    });
};

sdk.models.ShopTransfer.getNearestWarehouse = async (data) => {
    return await ShopTransfer_fetch('/models/ShopTransfer/getNearestWarehouse', {
        method: 'POST',
        body: data
    });
};
sdk.models.ShopTransferItem = {};

const ShopTransferItem_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur ShopTransferItem_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.ShopTransferItem.create = async (model) => {
    return await ShopTransferItem_fetch('/models/ShopTransferItem', {
        method: 'POST',
        body: model
    });
};

sdk.models.ShopTransferItem.getAll = async () => {
    return await ShopTransferItem_fetch('/models/ShopTransferItem');
};

sdk.models.ShopTransferItem.getOne = async (id) => {
    const cacheKey = "ShopTransferItem_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await ShopTransferItem_fetch('/models/ShopTransferItem/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.ShopTransferItem.update = async (id, model) => {
    localStorage.removeItem("ShopTransferItem_one_" + id);
    return await ShopTransferItem_fetch('/models/ShopTransferItem/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.ShopTransferItem.delete = async (id) => {
    return await ShopTransferItem_fetch('/models/ShopTransferItem/' + id, {
        method: 'DELETE'
    });
};

sdk.models.ShopTransferItem.setQuantity = async (data) => {
    return await ShopTransferItem_fetch('/models/ShopTransferItem/setQuantity', {
        method: 'POST',
        body: data
    });
};

sdk.models.ShopTransferItem.getQuantity = async (data) => {
    return await ShopTransferItem_fetch('/models/ShopTransferItem/getQuantity', {
        method: 'POST',
        body: data
    });
};

sdk.models.ShopTransferItem.getList = async (data) => {
    return await ShopTransferItem_fetch('/models/ShopTransferItem/getList', {
        method: 'POST',
        body: data
    });
};

sdk.models.ShopTransferItem.transferDone = async (data) => {
    return await ShopTransferItem_fetch('/models/ShopTransferItem/transferDone', {
        method: 'POST',
        body: data
    });
};
sdk.models.ShopEntrepotItem = {};

const ShopEntrepotItem_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur ShopEntrepotItem_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.ShopEntrepotItem.create = async (model) => {
    return await ShopEntrepotItem_fetch('/models/ShopEntrepotItem', {
        method: 'POST',
        body: model
    });
};

sdk.models.ShopEntrepotItem.getAll = async () => {
    return await ShopEntrepotItem_fetch('/models/ShopEntrepotItem');
};

sdk.models.ShopEntrepotItem.getOne = async (id) => {
    const cacheKey = "ShopEntrepotItem_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await ShopEntrepotItem_fetch('/models/ShopEntrepotItem/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.ShopEntrepotItem.update = async (id, model) => {
    localStorage.removeItem("ShopEntrepotItem_one_" + id);
    return await ShopEntrepotItem_fetch('/models/ShopEntrepotItem/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.ShopEntrepotItem.delete = async (id) => {
    return await ShopEntrepotItem_fetch('/models/ShopEntrepotItem/' + id, {
        method: 'DELETE'
    });
};

sdk.models.ShopEntrepotItem.stillExist = async (data) => {
    return await ShopEntrepotItem_fetch('/models/ShopEntrepotItem/stillExist', {
        method: 'POST',
        body: data
    });
};

sdk.models.ShopEntrepotItem.lockItem = async (data) => {
    return await ShopEntrepotItem_fetch('/models/ShopEntrepotItem/lockItem', {
        method: 'POST',
        body: data
    });
};

sdk.models.ShopEntrepotItem.getLockedItem = async (data) => {
    return await ShopEntrepotItem_fetch('/models/ShopEntrepotItem/getLockedItem', {
        method: 'POST',
        body: data
    });
};

sdk.models.ShopEntrepotItem.removeItem = async (data) => {
    return await ShopEntrepotItem_fetch('/models/ShopEntrepotItem/removeItem', {
        method: 'POST',
        body: data
    });
};

sdk.models.ShopEntrepotItem.getItemInventory = async (data) => {
    return await ShopEntrepotItem_fetch('/models/ShopEntrepotItem/getItemInventory', {
        method: 'POST',
        body: data
    });
};
sdk.models.ShopItemMedia = {};

const ShopItemMedia_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur ShopItemMedia_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.ShopItemMedia.create = async (model) => {
    return await ShopItemMedia_fetch('/models/ShopItemMedia', {
        method: 'POST',
        body: model
    });
};

sdk.models.ShopItemMedia.getAll = async () => {
    return await ShopItemMedia_fetch('/models/ShopItemMedia');
};

sdk.models.ShopItemMedia.getOne = async (id) => {
    const cacheKey = "ShopItemMedia_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await ShopItemMedia_fetch('/models/ShopItemMedia/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.ShopItemMedia.update = async (id, model) => {
    localStorage.removeItem("ShopItemMedia_one_" + id);
    return await ShopItemMedia_fetch('/models/ShopItemMedia/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.ShopItemMedia.delete = async (id) => {
    return await ShopItemMedia_fetch('/models/ShopItemMedia/' + id, {
        method: 'DELETE'
    });
};

sdk.models.ShopItemMedia.getItemMedias = async (data) => {
    return await ShopItemMedia_fetch('/models/ShopItemMedia/getItemMedias', {
        method: 'POST',
        body: data
    });
};
sdk.models.SocialCommentLike = {};

const SocialCommentLike_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur SocialCommentLike_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.SocialCommentLike.create = async (model) => {
    return await SocialCommentLike_fetch('/models/SocialCommentLike', {
        method: 'POST',
        body: model
    });
};

sdk.models.SocialCommentLike.getAll = async () => {
    return await SocialCommentLike_fetch('/models/SocialCommentLike');
};

sdk.models.SocialCommentLike.getOne = async (id) => {
    const cacheKey = "SocialCommentLike_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await SocialCommentLike_fetch('/models/SocialCommentLike/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.SocialCommentLike.update = async (id, model) => {
    localStorage.removeItem("SocialCommentLike_one_" + id);
    return await SocialCommentLike_fetch('/models/SocialCommentLike/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.SocialCommentLike.delete = async (id) => {
    return await SocialCommentLike_fetch('/models/SocialCommentLike/' + id, {
        method: 'DELETE'
    });
};

sdk.models.SocialCommentLike.hasLiked = async (data) => {
    return await SocialCommentLike_fetch('/models/SocialCommentLike/hasLiked', {
        method: 'POST',
        body: data
    });
};

sdk.models.SocialCommentLike.onCreate = async (data) => {
    return await SocialCommentLike_fetch('/models/SocialCommentLike/onCreate', {
        method: 'POST',
        body: data
    });
};

sdk.models.SocialCommentLike.deleteMyLike = async (data) => {
    return await SocialCommentLike_fetch('/models/SocialCommentLike/deleteMyLike', {
        method: 'POST',
        body: data
    });
};
sdk.models.BingoGame = {};

const BingoGame_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur BingoGame_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.BingoGame.create = async (model) => {
    return await BingoGame_fetch('/models/BingoGame', {
        method: 'POST',
        body: model
    });
};

sdk.models.BingoGame.getAll = async () => {
    return await BingoGame_fetch('/models/BingoGame');
};

sdk.models.BingoGame.getOne = async (id) => {
    const cacheKey = "BingoGame_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await BingoGame_fetch('/models/BingoGame/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.BingoGame.update = async (id, model) => {
    localStorage.removeItem("BingoGame_one_" + id);
    return await BingoGame_fetch('/models/BingoGame/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.BingoGame.delete = async (id) => {
    return await BingoGame_fetch('/models/BingoGame/' + id, {
        method: 'DELETE'
    });
};

sdk.models.BingoGame.initModel = async (data) => {
    return await BingoGame_fetch('/models/BingoGame/initModel', {
        method: 'POST',
        body: data
    });
};

sdk.models.BingoGame.getGame = async (data) => {
    return await BingoGame_fetch('/models/BingoGame/getGame', {
        method: 'POST',
        body: data
    });
};

sdk.models.BingoGame.checkCard = async (data) => {
    return await BingoGame_fetch('/models/BingoGame/checkCard', {
        method: 'POST',
        body: data
    });
};

sdk.models.BingoGame.getCurrentPlayer = async (data) => {
    return await BingoGame_fetch('/models/BingoGame/getCurrentPlayer', {
        method: 'POST',
        body: data
    });
};
sdk.models.BingoPlayer = {};

const BingoPlayer_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur BingoPlayer_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.BingoPlayer.create = async (model) => {
    return await BingoPlayer_fetch('/models/BingoPlayer', {
        method: 'POST',
        body: model
    });
};

sdk.models.BingoPlayer.getAll = async () => {
    return await BingoPlayer_fetch('/models/BingoPlayer');
};

sdk.models.BingoPlayer.getOne = async (id) => {
    const cacheKey = "BingoPlayer_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await BingoPlayer_fetch('/models/BingoPlayer/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.BingoPlayer.update = async (id, model) => {
    localStorage.removeItem("BingoPlayer_one_" + id);
    return await BingoPlayer_fetch('/models/BingoPlayer/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.BingoPlayer.delete = async (id) => {
    return await BingoPlayer_fetch('/models/BingoPlayer/' + id, {
        method: 'DELETE'
    });
};

sdk.models.BingoPlayer.getCard = async (data) => {
    return await BingoPlayer_fetch('/models/BingoPlayer/getCard', {
        method: 'POST',
        body: data
    });
};

sdk.models.BingoPlayer.getNbrPlayers = async (data) => {
    return await BingoPlayer_fetch('/models/BingoPlayer/getNbrPlayers', {
        method: 'POST',
        body: data
    });
};

sdk.models.BingoPlayer.getPlayers = async (data) => {
    return await BingoPlayer_fetch('/models/BingoPlayer/getPlayers', {
        method: 'POST',
        body: data
    });
};

sdk.models.BingoPlayer.getListAllPlayers = async (data) => {
    return await BingoPlayer_fetch('/models/BingoPlayer/getListAllPlayers', {
        method: 'POST',
        body: data
    });
};
sdk.models.ShopCartItem = {};

const ShopCartItem_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur ShopCartItem_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.ShopCartItem.create = async (model) => {
    return await ShopCartItem_fetch('/models/ShopCartItem', {
        method: 'POST',
        body: model
    });
};

sdk.models.ShopCartItem.getAll = async () => {
    return await ShopCartItem_fetch('/models/ShopCartItem');
};

sdk.models.ShopCartItem.getOne = async (id) => {
    const cacheKey = "ShopCartItem_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await ShopCartItem_fetch('/models/ShopCartItem/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.ShopCartItem.update = async (id, model) => {
    localStorage.removeItem("ShopCartItem_one_" + id);
    return await ShopCartItem_fetch('/models/ShopCartItem/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.ShopCartItem.delete = async (id) => {
    return await ShopCartItem_fetch('/models/ShopCartItem/' + id, {
        method: 'DELETE'
    });
};

sdk.models.ShopCartItem.getCartItem = async (data) => {
    return await ShopCartItem_fetch('/models/ShopCartItem/getCartItem', {
        method: 'POST',
        body: data
    });
};

sdk.models.ShopCartItem.getUserItems = async (data) => {
    return await ShopCartItem_fetch('/models/ShopCartItem/getUserItems', {
        method: 'POST',
        body: data
    });
};

sdk.models.ShopCartItem.deleteItem = async (data) => {
    return await ShopCartItem_fetch('/models/ShopCartItem/deleteItem', {
        method: 'POST',
        body: data
    });
};

sdk.models.ShopCartItem.getShippingCost = async (data) => {
    return await ShopCartItem_fetch('/models/ShopCartItem/getShippingCost', {
        method: 'POST',
        body: data
    });
};

sdk.models.ShopCartItem.createPaymentIntent = async (data) => {
    return await ShopCartItem_fetch('/models/ShopCartItem/createPaymentIntent', {
        method: 'POST',
        body: data
    });
};

sdk.models.ShopCartItem.initModel = async (data) => {
    return await ShopCartItem_fetch('/models/ShopCartItem/initModel', {
        method: 'POST',
        body: data
    });
};

sdk.models.ShopCartItem.paymentMade = async (data) => {
    return await ShopCartItem_fetch('/models/ShopCartItem/paymentMade', {
        method: 'POST',
        body: data
    });
};
sdk.models.UserAudience = {};

const UserAudience_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur UserAudience_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.UserAudience.create = async (model) => {
    return await UserAudience_fetch('/models/UserAudience', {
        method: 'POST',
        body: model
    });
};

sdk.models.UserAudience.getAll = async () => {
    return await UserAudience_fetch('/models/UserAudience');
};

sdk.models.UserAudience.getOne = async (id) => {
    const cacheKey = "UserAudience_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await UserAudience_fetch('/models/UserAudience/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.UserAudience.update = async (id, model) => {
    localStorage.removeItem("UserAudience_one_" + id);
    return await UserAudience_fetch('/models/UserAudience/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.UserAudience.delete = async (id) => {
    return await UserAudience_fetch('/models/UserAudience/' + id, {
        method: 'DELETE'
    });
};

sdk.models.UserAudience.doUser = async (data) => {
    return await UserAudience_fetch('/models/UserAudience/doUser', {
        method: 'POST',
        body: data
    });
};

sdk.models.UserAudience.getAudiences = async (data) => {
    return await UserAudience_fetch('/models/UserAudience/getAudiences', {
        method: 'POST',
        body: data
    });
};

sdk.models.UserAudience.cronDoUser = async (data) => {
    return await UserAudience_fetch('/models/UserAudience/cronDoUser', {
        method: 'POST',
        body: data
    });
};

sdk.models.UserAudience.getUserAudience = async (data) => {
    return await UserAudience_fetch('/models/UserAudience/getUserAudience', {
        method: 'POST',
        body: data
    });
};

sdk.models.UserAudience.addAudience = async (data) => {
    return await UserAudience_fetch('/models/UserAudience/addAudience', {
        method: 'POST',
        body: data
    });
};

sdk.models.UserAudience.getIntelAudience = async (data) => {
    return await UserAudience_fetch('/models/UserAudience/getIntelAudience', {
        method: 'POST',
        body: data
    });
};

sdk.models.UserAudience.redoAll = async (data) => {
    return await UserAudience_fetch('/models/UserAudience/redoAll', {
        method: 'POST',
        body: data
    });
};
sdk.models.StorBarcode = {};

const StorBarcode_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur StorBarcode_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.StorBarcode.create = async (model) => {
    return await StorBarcode_fetch('/models/StorBarcode', {
        method: 'POST',
        body: model
    });
};

sdk.models.StorBarcode.getAll = async () => {
    return await StorBarcode_fetch('/models/StorBarcode');
};

sdk.models.StorBarcode.getOne = async (id) => {
    const cacheKey = "StorBarcode_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await StorBarcode_fetch('/models/StorBarcode/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.StorBarcode.update = async (id, model) => {
    localStorage.removeItem("StorBarcode_one_" + id);
    return await StorBarcode_fetch('/models/StorBarcode/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.StorBarcode.delete = async (id) => {
    return await StorBarcode_fetch('/models/StorBarcode/' + id, {
        method: 'DELETE'
    });
};

sdk.models.StorBarcode.getProduct = async (data) => {
    return await StorBarcode_fetch('/models/StorBarcode/getProduct', {
        method: 'POST',
        body: data
    });
};
sdk.models.ImageImpot = {};

const ImageImpot_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur ImageImpot_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.ImageImpot.create = async (model) => {
    return await ImageImpot_fetch('/models/ImageImpot', {
        method: 'POST',
        body: model
    });
};

sdk.models.ImageImpot.getAll = async () => {
    return await ImageImpot_fetch('/models/ImageImpot');
};

sdk.models.ImageImpot.getOne = async (id) => {
    const cacheKey = "ImageImpot_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await ImageImpot_fetch('/models/ImageImpot/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.ImageImpot.update = async (id, model) => {
    localStorage.removeItem("ImageImpot_one_" + id);
    return await ImageImpot_fetch('/models/ImageImpot/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.ImageImpot.delete = async (id) => {
    return await ImageImpot_fetch('/models/ImageImpot/' + id, {
        method: 'DELETE'
    });
};

sdk.models.ImageImpot.getImages = async (data) => {
    return await ImageImpot_fetch('/models/ImageImpot/getImages', {
        method: 'POST',
        body: data
    });
};
sdk.models.PeupleAi = {};

const PeupleAi_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur PeupleAi_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.PeupleAi.create = async (model) => {
    return await PeupleAi_fetch('/models/PeupleAi', {
        method: 'POST',
        body: model
    });
};

sdk.models.PeupleAi.getAll = async () => {
    return await PeupleAi_fetch('/models/PeupleAi');
};

sdk.models.PeupleAi.getOne = async (id) => {
    const cacheKey = "PeupleAi_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await PeupleAi_fetch('/models/PeupleAi/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.PeupleAi.update = async (id, model) => {
    localStorage.removeItem("PeupleAi_one_" + id);
    return await PeupleAi_fetch('/models/PeupleAi/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.PeupleAi.delete = async (id) => {
    return await PeupleAi_fetch('/models/PeupleAi/' + id, {
        method: 'DELETE'
    });
};

sdk.models.PeupleAi.doCamille = async (data) => {
    return await PeupleAi_fetch('/models/PeupleAi/doCamille', {
        method: 'POST',
        body: data
    });
};

sdk.models.PeupleAi.doCamilleMorning = async (data) => {
    return await PeupleAi_fetch('/models/PeupleAi/doCamilleMorning', {
        method: 'POST',
        body: data
    });
};

sdk.models.PeupleAi.doCamilleApresMidi = async (data) => {
    return await PeupleAi_fetch('/models/PeupleAi/doCamilleApresMidi', {
        method: 'POST',
        body: data
    });
};

sdk.models.PeupleAi.doCamilleMorningPost = async (data) => {
    return await PeupleAi_fetch('/models/PeupleAi/doCamilleMorningPost', {
        method: 'POST',
        body: data
    });
};
sdk.models.PageUsers = {};

const PageUsers_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur PageUsers_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.PageUsers.create = async (model) => {
    return await PageUsers_fetch('/models/PageUsers', {
        method: 'POST',
        body: model
    });
};

sdk.models.PageUsers.getAll = async () => {
    return await PageUsers_fetch('/models/PageUsers');
};

sdk.models.PageUsers.getOne = async (id) => {
    const cacheKey = "PageUsers_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await PageUsers_fetch('/models/PageUsers/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.PageUsers.update = async (id, model) => {
    localStorage.removeItem("PageUsers_one_" + id);
    return await PageUsers_fetch('/models/PageUsers/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.PageUsers.delete = async (id) => {
    return await PageUsers_fetch('/models/PageUsers/' + id, {
        method: 'DELETE'
    });
};

sdk.models.PageUsers.createPageUser = async (data) => {
    return await PageUsers_fetch('/models/PageUsers/createPageUser', {
        method: 'POST',
        body: data
    });
};

sdk.models.PageUsers.deletePageUser = async (data) => {
    return await PageUsers_fetch('/models/PageUsers/deletePageUser', {
        method: 'POST',
        body: data
    });
};

sdk.models.PageUsers.getPageUsers = async (data) => {
    return await PageUsers_fetch('/models/PageUsers/getPageUsers', {
        method: 'POST',
        body: data
    });
};

sdk.models.PageUsers.searchUser = async (data) => {
    return await PageUsers_fetch('/models/PageUsers/searchUser', {
        method: 'POST',
        body: data
    });
};
sdk.models.FbPage = {};

const FbPage_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur FbPage_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.FbPage.create = async (model) => {
    return await FbPage_fetch('/models/FbPage', {
        method: 'POST',
        body: model
    });
};

sdk.models.FbPage.getAll = async () => {
    return await FbPage_fetch('/models/FbPage');
};

sdk.models.FbPage.getOne = async (id) => {
    const cacheKey = "FbPage_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await FbPage_fetch('/models/FbPage/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.FbPage.update = async (id, model) => {
    localStorage.removeItem("FbPage_one_" + id);
    return await FbPage_fetch('/models/FbPage/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.FbPage.delete = async (id) => {
    return await FbPage_fetch('/models/FbPage/' + id, {
        method: 'DELETE'
    });
};

sdk.models.FbPage.timer = async (data) => {
    return await FbPage_fetch('/models/FbPage/timer', {
        method: 'POST',
        body: data
    });
};

sdk.models.FbPage.onUpdate = async (data) => {
    return await FbPage_fetch('/models/FbPage/onUpdate', {
        method: 'POST',
        body: data
    });
};

sdk.models.FbPage.getFromUrl = async (data) => {
    return await FbPage_fetch('/models/FbPage/getFromUrl', {
        method: 'POST',
        body: data
    });
};
sdk.models.VirtualJobUser = {};

const VirtualJobUser_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur VirtualJobUser_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.VirtualJobUser.create = async (model) => {
    return await VirtualJobUser_fetch('/models/VirtualJobUser', {
        method: 'POST',
        body: model
    });
};

sdk.models.VirtualJobUser.getAll = async () => {
    return await VirtualJobUser_fetch('/models/VirtualJobUser');
};

sdk.models.VirtualJobUser.getOne = async (id) => {
    const cacheKey = "VirtualJobUser_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await VirtualJobUser_fetch('/models/VirtualJobUser/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.VirtualJobUser.update = async (id, model) => {
    localStorage.removeItem("VirtualJobUser_one_" + id);
    return await VirtualJobUser_fetch('/models/VirtualJobUser/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.VirtualJobUser.delete = async (id) => {
    return await VirtualJobUser_fetch('/models/VirtualJobUser/' + id, {
        method: 'DELETE'
    });
};

sdk.models.VirtualJobUser.updateUser = async (data) => {
    return await VirtualJobUser_fetch('/models/VirtualJobUser/updateUser', {
        method: 'POST',
        body: data
    });
};

sdk.models.VirtualJobUser.getMine = async (data) => {
    return await VirtualJobUser_fetch('/models/VirtualJobUser/getMine', {
        method: 'POST',
        body: data
    });
};

sdk.models.VirtualJobUser.getListForHiring = async (data) => {
    return await VirtualJobUser_fetch('/models/VirtualJobUser/getListForHiring', {
        method: 'POST',
        body: data
    });
};

sdk.models.VirtualJobUser.hire = async (data) => {
    return await VirtualJobUser_fetch('/models/VirtualJobUser/hire', {
        method: 'POST',
        body: data
    });
};

sdk.models.VirtualJobUser.getWorkers = async (data) => {
    return await VirtualJobUser_fetch('/models/VirtualJobUser/getWorkers', {
        method: 'POST',
        body: data
    });
};
sdk.models.InteracPayment = {};

const InteracPayment_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur InteracPayment_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.InteracPayment.create = async (model) => {
    return await InteracPayment_fetch('/models/InteracPayment', {
        method: 'POST',
        body: model
    });
};

sdk.models.InteracPayment.getAll = async () => {
    return await InteracPayment_fetch('/models/InteracPayment');
};

sdk.models.InteracPayment.getOne = async (id) => {
    const cacheKey = "InteracPayment_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await InteracPayment_fetch('/models/InteracPayment/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.InteracPayment.update = async (id, model) => {
    localStorage.removeItem("InteracPayment_one_" + id);
    return await InteracPayment_fetch('/models/InteracPayment/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.InteracPayment.delete = async (id) => {
    return await InteracPayment_fetch('/models/InteracPayment/' + id, {
        method: 'DELETE'
    });
};
sdk.models.ClaudeAi = {};

const ClaudeAi_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur ClaudeAi_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.ClaudeAi.create = async (model) => {
    return await ClaudeAi_fetch('/models/ClaudeAi', {
        method: 'POST',
        body: model
    });
};

sdk.models.ClaudeAi.getAll = async () => {
    return await ClaudeAi_fetch('/models/ClaudeAi');
};

sdk.models.ClaudeAi.getOne = async (id) => {
    const cacheKey = "ClaudeAi_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await ClaudeAi_fetch('/models/ClaudeAi/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.ClaudeAi.update = async (id, model) => {
    localStorage.removeItem("ClaudeAi_one_" + id);
    return await ClaudeAi_fetch('/models/ClaudeAi/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.ClaudeAi.delete = async (id) => {
    return await ClaudeAi_fetch('/models/ClaudeAi/' + id, {
        method: 'DELETE'
    });
};

sdk.models.ClaudeAi.ask = async (data) => {
    return await ClaudeAi_fetch('/models/ClaudeAi/ask', {
        method: 'POST',
        body: data
    });
};

sdk.models.ClaudeAi.getModels = async (data) => {
    return await ClaudeAi_fetch('/models/ClaudeAi/getModels', {
        method: 'POST',
        body: data
    });
};
sdk.models.VirtualAccount = {};

const VirtualAccount_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur VirtualAccount_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.VirtualAccount.create = async (model) => {
    return await VirtualAccount_fetch('/models/VirtualAccount', {
        method: 'POST',
        body: model
    });
};

sdk.models.VirtualAccount.getAll = async () => {
    return await VirtualAccount_fetch('/models/VirtualAccount');
};

sdk.models.VirtualAccount.getOne = async (id) => {
    const cacheKey = "VirtualAccount_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await VirtualAccount_fetch('/models/VirtualAccount/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.VirtualAccount.update = async (id, model) => {
    localStorage.removeItem("VirtualAccount_one_" + id);
    return await VirtualAccount_fetch('/models/VirtualAccount/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.VirtualAccount.delete = async (id) => {
    return await VirtualAccount_fetch('/models/VirtualAccount/' + id, {
        method: 'DELETE'
    });
};

sdk.models.VirtualAccount.getAccounts = async (data) => {
    return await VirtualAccount_fetch('/models/VirtualAccount/getAccounts', {
        method: 'POST',
        body: data
    });
};

sdk.models.VirtualAccount.timer = async (data) => {
    return await VirtualAccount_fetch('/models/VirtualAccount/timer', {
        method: 'POST',
        body: data
    });
};

sdk.models.VirtualAccount.getAccount = async (data) => {
    return await VirtualAccount_fetch('/models/VirtualAccount/getAccount', {
        method: 'POST',
        body: data
    });
};

sdk.models.VirtualAccount.getMines = async (data) => {
    return await VirtualAccount_fetch('/models/VirtualAccount/getMines', {
        method: 'POST',
        body: data
    });
};
sdk.models.FbGroupAccount = {};

const FbGroupAccount_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur FbGroupAccount_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.FbGroupAccount.create = async (model) => {
    return await FbGroupAccount_fetch('/models/FbGroupAccount', {
        method: 'POST',
        body: model
    });
};

sdk.models.FbGroupAccount.getAll = async () => {
    return await FbGroupAccount_fetch('/models/FbGroupAccount');
};

sdk.models.FbGroupAccount.getOne = async (id) => {
    const cacheKey = "FbGroupAccount_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await FbGroupAccount_fetch('/models/FbGroupAccount/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.FbGroupAccount.update = async (id, model) => {
    localStorage.removeItem("FbGroupAccount_one_" + id);
    return await FbGroupAccount_fetch('/models/FbGroupAccount/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.FbGroupAccount.delete = async (id) => {
    return await FbGroupAccount_fetch('/models/FbGroupAccount/' + id, {
        method: 'DELETE'
    });
};

sdk.models.FbGroupAccount.getUserGroups = async (data) => {
    return await FbGroupAccount_fetch('/models/FbGroupAccount/getUserGroups', {
        method: 'POST',
        body: data
    });
};

sdk.models.FbGroupAccount.cancel = async (data) => {
    return await FbGroupAccount_fetch('/models/FbGroupAccount/cancel', {
        method: 'POST',
        body: data
    });
};

sdk.models.FbGroupAccount.getWorking = async (data) => {
    return await FbGroupAccount_fetch('/models/FbGroupAccount/getWorking', {
        method: 'POST',
        body: data
    });
};

sdk.models.FbGroupAccount.getWorkingDetailed = async (data) => {
    return await FbGroupAccount_fetch('/models/FbGroupAccount/getWorkingDetailed', {
        method: 'POST',
        body: data
    });
};

sdk.models.FbGroupAccount.sendPost = async (data) => {
    return await FbGroupAccount_fetch('/models/FbGroupAccount/sendPost', {
        method: 'POST',
        body: data
    });
};

sdk.models.FbGroupAccount.getAllUserGroups = async (data) => {
    return await FbGroupAccount_fetch('/models/FbGroupAccount/getAllUserGroups', {
        method: 'POST',
        body: data
    });
};
sdk.models.ChatGpt = {};

const ChatGpt_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur ChatGpt_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.ChatGpt.create = async (model) => {
    return await ChatGpt_fetch('/models/ChatGpt', {
        method: 'POST',
        body: model
    });
};

sdk.models.ChatGpt.getAll = async () => {
    return await ChatGpt_fetch('/models/ChatGpt');
};

sdk.models.ChatGpt.getOne = async (id) => {
    const cacheKey = "ChatGpt_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await ChatGpt_fetch('/models/ChatGpt/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.ChatGpt.update = async (id, model) => {
    localStorage.removeItem("ChatGpt_one_" + id);
    return await ChatGpt_fetch('/models/ChatGpt/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.ChatGpt.delete = async (id) => {
    return await ChatGpt_fetch('/models/ChatGpt/' + id, {
        method: 'DELETE'
    });
};

sdk.models.ChatGpt.initModel = async (data) => {
    return await ChatGpt_fetch('/models/ChatGpt/initModel', {
        method: 'POST',
        body: data
    });
};

sdk.models.ChatGpt.newCrmEmail = async (data) => {
    return await ChatGpt_fetch('/models/ChatGpt/newCrmEmail', {
        method: 'POST',
        body: data
    });
};

sdk.models.ChatGpt.createCrmEmail = async (data) => {
    return await ChatGpt_fetch('/models/ChatGpt/createCrmEmail', {
        method: 'POST',
        body: data
    });
};

sdk.models.ChatGpt.ask = async (data) => {
    return await ChatGpt_fetch('/models/ChatGpt/ask', {
        method: 'POST',
        body: data
    });
};

sdk.models.ChatGpt.getModels = async (data) => {
    return await ChatGpt_fetch('/models/ChatGpt/getModels', {
        method: 'POST',
        body: data
    });
};
sdk.models.WebUrl = {};

const WebUrl_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur WebUrl_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.WebUrl.create = async (model) => {
    return await WebUrl_fetch('/models/WebUrl', {
        method: 'POST',
        body: model
    });
};

sdk.models.WebUrl.getAll = async () => {
    return await WebUrl_fetch('/models/WebUrl');
};

sdk.models.WebUrl.getOne = async (id) => {
    const cacheKey = "WebUrl_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await WebUrl_fetch('/models/WebUrl/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.WebUrl.update = async (id, model) => {
    localStorage.removeItem("WebUrl_one_" + id);
    return await WebUrl_fetch('/models/WebUrl/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.WebUrl.delete = async (id) => {
    return await WebUrl_fetch('/models/WebUrl/' + id, {
        method: 'DELETE'
    });
};

sdk.models.WebUrl.addUrl = async (data) => {
    return await WebUrl_fetch('/models/WebUrl/addUrl', {
        method: 'POST',
        body: data
    });
};

sdk.models.WebUrl.findByUrl = async (data) => {
    return await WebUrl_fetch('/models/WebUrl/findByUrl', {
        method: 'POST',
        body: data
    });
};
sdk.models.WebEmail = {};

const WebEmail_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur WebEmail_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.WebEmail.create = async (model) => {
    return await WebEmail_fetch('/models/WebEmail', {
        method: 'POST',
        body: model
    });
};

sdk.models.WebEmail.getAll = async () => {
    return await WebEmail_fetch('/models/WebEmail');
};

sdk.models.WebEmail.getOne = async (id) => {
    const cacheKey = "WebEmail_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await WebEmail_fetch('/models/WebEmail/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.WebEmail.update = async (id, model) => {
    localStorage.removeItem("WebEmail_one_" + id);
    return await WebEmail_fetch('/models/WebEmail/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.WebEmail.delete = async (id) => {
    return await WebEmail_fetch('/models/WebEmail/' + id, {
        method: 'DELETE'
    });
};

sdk.models.WebEmail.getEmailsFromDomains = async (data) => {
    return await WebEmail_fetch('/models/WebEmail/getEmailsFromDomains', {
        method: 'POST',
        body: data
    });
};
sdk.models.MarketingEmail = {};

const MarketingEmail_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur MarketingEmail_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.MarketingEmail.create = async (model) => {
    return await MarketingEmail_fetch('/models/MarketingEmail', {
        method: 'POST',
        body: model
    });
};

sdk.models.MarketingEmail.getAll = async () => {
    return await MarketingEmail_fetch('/models/MarketingEmail');
};

sdk.models.MarketingEmail.getOne = async (id) => {
    const cacheKey = "MarketingEmail_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await MarketingEmail_fetch('/models/MarketingEmail/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.MarketingEmail.update = async (id, model) => {
    localStorage.removeItem("MarketingEmail_one_" + id);
    return await MarketingEmail_fetch('/models/MarketingEmail/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.MarketingEmail.delete = async (id) => {
    return await MarketingEmail_fetch('/models/MarketingEmail/' + id, {
        method: 'DELETE'
    });
};

sdk.models.MarketingEmail.onUpdate = async (data) => {
    return await MarketingEmail_fetch('/models/MarketingEmail/onUpdate', {
        method: 'POST',
        body: data
    });
};

sdk.models.MarketingEmail.getCampaign = async (data) => {
    return await MarketingEmail_fetch('/models/MarketingEmail/getCampaign', {
        method: 'POST',
        body: data
    });
};

sdk.models.MarketingEmail.addEmail = async (data) => {
    return await MarketingEmail_fetch('/models/MarketingEmail/addEmail', {
        method: 'POST',
        body: data
    });
};
sdk.models.WebDomain = {};

const WebDomain_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur WebDomain_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.WebDomain.create = async (model) => {
    return await WebDomain_fetch('/models/WebDomain', {
        method: 'POST',
        body: model
    });
};

sdk.models.WebDomain.getAll = async () => {
    return await WebDomain_fetch('/models/WebDomain');
};

sdk.models.WebDomain.getOne = async (id) => {
    const cacheKey = "WebDomain_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await WebDomain_fetch('/models/WebDomain/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.WebDomain.update = async (id, model) => {
    localStorage.removeItem("WebDomain_one_" + id);
    return await WebDomain_fetch('/models/WebDomain/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.WebDomain.delete = async (id) => {
    return await WebDomain_fetch('/models/WebDomain/' + id, {
        method: 'DELETE'
    });
};

sdk.models.WebDomain.getDomain = async (data) => {
    return await WebDomain_fetch('/models/WebDomain/getDomain', {
        method: 'POST',
        body: data
    });
};

sdk.models.WebDomain.search = async (data) => {
    return await WebDomain_fetch('/models/WebDomain/search', {
        method: 'POST',
        body: data
    });
};
sdk.models.AiAgent = {};

const AiAgent_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur AiAgent_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.AiAgent.create = async (model) => {
    return await AiAgent_fetch('/models/AiAgent', {
        method: 'POST',
        body: model
    });
};

sdk.models.AiAgent.getAll = async () => {
    return await AiAgent_fetch('/models/AiAgent');
};

sdk.models.AiAgent.getOne = async (id) => {
    const cacheKey = "AiAgent_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await AiAgent_fetch('/models/AiAgent/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.AiAgent.update = async (id, model) => {
    localStorage.removeItem("AiAgent_one_" + id);
    return await AiAgent_fetch('/models/AiAgent/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.AiAgent.delete = async (id) => {
    return await AiAgent_fetch('/models/AiAgent/' + id, {
        method: 'DELETE'
    });
};

sdk.models.AiAgent.updateAgentTimer = async (data) => {
    return await AiAgent_fetch('/models/AiAgent/updateAgentTimer', {
        method: 'POST',
        body: data
    });
};

sdk.models.AiAgent.askAgent = async (data) => {
    return await AiAgent_fetch('/models/AiAgent/askAgent', {
        method: 'POST',
        body: data
    });
};

sdk.models.AiAgent.askCoder = async (data) => {
    return await AiAgent_fetch('/models/AiAgent/askCoder', {
        method: 'POST',
        body: data
    });
};

sdk.models.AiAgent.testTimer = async (data) => {
    return await AiAgent_fetch('/models/AiAgent/testTimer', {
        method: 'POST',
        body: data
    });
};

sdk.models.AiAgent.getAgent = async (data) => {
    return await AiAgent_fetch('/models/AiAgent/getAgent', {
        method: 'POST',
        body: data
    });
};

sdk.models.AiAgent.newCrmEmail = async (data) => {
    return await AiAgent_fetch('/models/AiAgent/newCrmEmail', {
        method: 'POST',
        body: data
    });
};
sdk.models.CrmContact = {};

const CrmContact_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur CrmContact_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.CrmContact.create = async (model) => {
    return await CrmContact_fetch('/models/CrmContact', {
        method: 'POST',
        body: model
    });
};

sdk.models.CrmContact.getAll = async () => {
    return await CrmContact_fetch('/models/CrmContact');
};

sdk.models.CrmContact.getOne = async (id) => {
    const cacheKey = "CrmContact_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await CrmContact_fetch('/models/CrmContact/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.CrmContact.update = async (id, model) => {
    localStorage.removeItem("CrmContact_one_" + id);
    return await CrmContact_fetch('/models/CrmContact/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.CrmContact.delete = async (id) => {
    return await CrmContact_fetch('/models/CrmContact/' + id, {
        method: 'DELETE'
    });
};

sdk.models.CrmContact.findByEmail = async (data) => {
    return await CrmContact_fetch('/models/CrmContact/findByEmail', {
        method: 'POST',
        body: data
    });
};
sdk.models.AiCommand = {};

const AiCommand_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur AiCommand_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.AiCommand.create = async (model) => {
    return await AiCommand_fetch('/models/AiCommand', {
        method: 'POST',
        body: model
    });
};

sdk.models.AiCommand.getAll = async () => {
    return await AiCommand_fetch('/models/AiCommand');
};

sdk.models.AiCommand.getOne = async (id) => {
    const cacheKey = "AiCommand_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await AiCommand_fetch('/models/AiCommand/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.AiCommand.update = async (id, model) => {
    localStorage.removeItem("AiCommand_one_" + id);
    return await AiCommand_fetch('/models/AiCommand/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.AiCommand.delete = async (id) => {
    return await AiCommand_fetch('/models/AiCommand/' + id, {
        method: 'DELETE'
    });
};

sdk.models.AiCommand.getAgentCommands = async (data) => {
    return await AiCommand_fetch('/models/AiCommand/getAgentCommands', {
        method: 'POST',
        body: data
    });
};
sdk.models.AdsZone = {};

const AdsZone_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur AdsZone_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.AdsZone.create = async (model) => {
    return await AdsZone_fetch('/models/AdsZone', {
        method: 'POST',
        body: model
    });
};

sdk.models.AdsZone.getAll = async () => {
    return await AdsZone_fetch('/models/AdsZone');
};

sdk.models.AdsZone.getOne = async (id) => {
    const cacheKey = "AdsZone_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await AdsZone_fetch('/models/AdsZone/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.AdsZone.update = async (id, model) => {
    localStorage.removeItem("AdsZone_one_" + id);
    return await AdsZone_fetch('/models/AdsZone/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.AdsZone.delete = async (id) => {
    return await AdsZone_fetch('/models/AdsZone/' + id, {
        method: 'DELETE'
    });
};

sdk.models.AdsZone.getZone = async (data) => {
    return await AdsZone_fetch('/models/AdsZone/getZone', {
        method: 'POST',
        body: data
    });
};
sdk.models.CrmEmail = {};

const CrmEmail_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur CrmEmail_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.CrmEmail.create = async (model) => {
    return await CrmEmail_fetch('/models/CrmEmail', {
        method: 'POST',
        body: model
    });
};

sdk.models.CrmEmail.getAll = async () => {
    return await CrmEmail_fetch('/models/CrmEmail');
};

sdk.models.CrmEmail.getOne = async (id) => {
    const cacheKey = "CrmEmail_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await CrmEmail_fetch('/models/CrmEmail/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.CrmEmail.update = async (id, model) => {
    localStorage.removeItem("CrmEmail_one_" + id);
    return await CrmEmail_fetch('/models/CrmEmail/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.CrmEmail.delete = async (id) => {
    return await CrmEmail_fetch('/models/CrmEmail/' + id, {
        method: 'DELETE'
    });
};

sdk.models.CrmEmail.getEmails = async (data) => {
    return await CrmEmail_fetch('/models/CrmEmail/getEmails', {
        method: 'POST',
        body: data
    });
};

sdk.models.CrmEmail.sendEmail = async (data) => {
    return await CrmEmail_fetch('/models/CrmEmail/sendEmail', {
        method: 'POST',
        body: data
    });
};

sdk.models.CrmEmail.timer = async (data) => {
    return await CrmEmail_fetch('/models/CrmEmail/timer', {
        method: 'POST',
        body: data
    });
};

sdk.models.CrmEmail.getByMessageId = async (data) => {
    return await CrmEmail_fetch('/models/CrmEmail/getByMessageId', {
        method: 'POST',
        body: data
    });
};

sdk.models.CrmEmail.getInbox = async (data) => {
    return await CrmEmail_fetch('/models/CrmEmail/getInbox', {
        method: 'POST',
        body: data
    });
};

sdk.models.CrmEmail.getOutbox = async (data) => {
    return await CrmEmail_fetch('/models/CrmEmail/getOutbox', {
        method: 'POST',
        body: data
    });
};
sdk.models.AiTask = {};

const AiTask_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur AiTask_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.AiTask.create = async (model) => {
    return await AiTask_fetch('/models/AiTask', {
        method: 'POST',
        body: model
    });
};

sdk.models.AiTask.getAll = async () => {
    return await AiTask_fetch('/models/AiTask');
};

sdk.models.AiTask.getOne = async (id) => {
    const cacheKey = "AiTask_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await AiTask_fetch('/models/AiTask/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.AiTask.update = async (id, model) => {
    localStorage.removeItem("AiTask_one_" + id);
    return await AiTask_fetch('/models/AiTask/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.AiTask.delete = async (id) => {
    return await AiTask_fetch('/models/AiTask/' + id, {
        method: 'DELETE'
    });
};

sdk.models.AiTask.onCreate = async (data) => {
    return await AiTask_fetch('/models/AiTask/onCreate', {
        method: 'POST',
        body: data
    });
};

sdk.models.AiTask.initModel = async (data) => {
    return await AiTask_fetch('/models/AiTask/initModel', {
        method: 'POST',
        body: data
    });
};
sdk.models.Queue = {};

const Queue_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur Queue_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.Queue.create = async (model) => {
    return await Queue_fetch('/models/Queue', {
        method: 'POST',
        body: model
    });
};

sdk.models.Queue.getAll = async () => {
    return await Queue_fetch('/models/Queue');
};

sdk.models.Queue.getOne = async (id) => {
    const cacheKey = "Queue_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await Queue_fetch('/models/Queue/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.Queue.update = async (id, model) => {
    localStorage.removeItem("Queue_one_" + id);
    return await Queue_fetch('/models/Queue/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.Queue.delete = async (id) => {
    return await Queue_fetch('/models/Queue/' + id, {
        method: 'DELETE'
    });
};

sdk.models.Queue.initModel = async (data) => {
    return await Queue_fetch('/models/Queue/initModel', {
        method: 'POST',
        body: data
    });
};

sdk.models.Queue.onUpdate = async (data) => {
    return await Queue_fetch('/models/Queue/onUpdate', {
        method: 'POST',
        body: data
    });
};

sdk.models.Queue.sendMessage = async (data) => {
    return await Queue_fetch('/models/Queue/sendMessage', {
        method: 'POST',
        body: data
    });
};
sdk.models.WebSocket = {};

const WebSocket_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur WebSocket_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.WebSocket.create = async (model) => {
    return await WebSocket_fetch('/models/WebSocket', {
        method: 'POST',
        body: model
    });
};

sdk.models.WebSocket.getAll = async () => {
    return await WebSocket_fetch('/models/WebSocket');
};

sdk.models.WebSocket.getOne = async (id) => {
    const cacheKey = "WebSocket_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await WebSocket_fetch('/models/WebSocket/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.WebSocket.update = async (id, model) => {
    localStorage.removeItem("WebSocket_one_" + id);
    return await WebSocket_fetch('/models/WebSocket/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.WebSocket.delete = async (id) => {
    return await WebSocket_fetch('/models/WebSocket/' + id, {
        method: 'DELETE'
    });
};
sdk.models.CrmCompany = {};

const CrmCompany_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur CrmCompany_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.CrmCompany.create = async (model) => {
    return await CrmCompany_fetch('/models/CrmCompany', {
        method: 'POST',
        body: model
    });
};

sdk.models.CrmCompany.getAll = async () => {
    return await CrmCompany_fetch('/models/CrmCompany');
};

sdk.models.CrmCompany.getOne = async (id) => {
    const cacheKey = "CrmCompany_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await CrmCompany_fetch('/models/CrmCompany/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.CrmCompany.update = async (id, model) => {
    localStorage.removeItem("CrmCompany_one_" + id);
    return await CrmCompany_fetch('/models/CrmCompany/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.CrmCompany.delete = async (id) => {
    return await CrmCompany_fetch('/models/CrmCompany/' + id, {
        method: 'DELETE'
    });
};

sdk.models.CrmCompany.findNeq = async (data) => {
    return await CrmCompany_fetch('/models/CrmCompany/findNeq', {
        method: 'POST',
        body: data
    });
};
sdk.models.CrmEmailAccount = {};

const CrmEmailAccount_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur CrmEmailAccount_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.CrmEmailAccount.create = async (model) => {
    return await CrmEmailAccount_fetch('/models/CrmEmailAccount', {
        method: 'POST',
        body: model
    });
};

sdk.models.CrmEmailAccount.getAll = async () => {
    return await CrmEmailAccount_fetch('/models/CrmEmailAccount');
};

sdk.models.CrmEmailAccount.getOne = async (id) => {
    const cacheKey = "CrmEmailAccount_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await CrmEmailAccount_fetch('/models/CrmEmailAccount/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.CrmEmailAccount.update = async (id, model) => {
    localStorage.removeItem("CrmEmailAccount_one_" + id);
    return await CrmEmailAccount_fetch('/models/CrmEmailAccount/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.CrmEmailAccount.delete = async (id) => {
    return await CrmEmailAccount_fetch('/models/CrmEmailAccount/' + id, {
        method: 'DELETE'
    });
};

sdk.models.CrmEmailAccount.getMine = async (data) => {
    return await CrmEmailAccount_fetch('/models/CrmEmailAccount/getMine', {
        method: 'POST',
        body: data
    });
};

sdk.models.CrmEmailAccount.getByEmail = async (data) => {
    return await CrmEmailAccount_fetch('/models/CrmEmailAccount/getByEmail', {
        method: 'POST',
        body: data
    });
};

sdk.models.CrmEmailAccount.getByUser = async (data) => {
    return await CrmEmailAccount_fetch('/models/CrmEmailAccount/getByUser', {
        method: 'POST',
        body: data
    });
};
sdk.models.MarketingEmailRecipient = {};

const MarketingEmailRecipient_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur MarketingEmailRecipient_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.MarketingEmailRecipient.create = async (model) => {
    return await MarketingEmailRecipient_fetch('/models/MarketingEmailRecipient', {
        method: 'POST',
        body: model
    });
};

sdk.models.MarketingEmailRecipient.getAll = async () => {
    return await MarketingEmailRecipient_fetch('/models/MarketingEmailRecipient');
};

sdk.models.MarketingEmailRecipient.getOne = async (id) => {
    const cacheKey = "MarketingEmailRecipient_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await MarketingEmailRecipient_fetch('/models/MarketingEmailRecipient/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.MarketingEmailRecipient.update = async (id, model) => {
    localStorage.removeItem("MarketingEmailRecipient_one_" + id);
    return await MarketingEmailRecipient_fetch('/models/MarketingEmailRecipient/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.MarketingEmailRecipient.delete = async (id) => {
    return await MarketingEmailRecipient_fetch('/models/MarketingEmailRecipient/' + id, {
        method: 'DELETE'
    });
};

sdk.models.MarketingEmailRecipient.onCreate = async (data) => {
    return await MarketingEmailRecipient_fetch('/models/MarketingEmailRecipient/onCreate', {
        method: 'POST',
        body: data
    });
};

sdk.models.MarketingEmailRecipient.getList = async (data) => {
    return await MarketingEmailRecipient_fetch('/models/MarketingEmailRecipient/getList', {
        method: 'POST',
        body: data
    });
};

sdk.models.MarketingEmailRecipient.addEmail = async (data) => {
    return await MarketingEmailRecipient_fetch('/models/MarketingEmailRecipient/addEmail', {
        method: 'POST',
        body: data
    });
};
sdk.models.Enom = {};

const Enom_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur Enom_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.Enom.create = async (model) => {
    return await Enom_fetch('/models/Enom', {
        method: 'POST',
        body: model
    });
};

sdk.models.Enom.getAll = async () => {
    return await Enom_fetch('/models/Enom');
};

sdk.models.Enom.getOne = async (id) => {
    const cacheKey = "Enom_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await Enom_fetch('/models/Enom/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.Enom.update = async (id, model) => {
    localStorage.removeItem("Enom_one_" + id);
    return await Enom_fetch('/models/Enom/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.Enom.delete = async (id) => {
    return await Enom_fetch('/models/Enom/' + id, {
        method: 'DELETE'
    });
};

sdk.models.Enom.initModel = async (data) => {
    return await Enom_fetch('/models/Enom/initModel', {
        method: 'POST',
        body: data
    });
};
sdk.models.CrmEtablissement = {};

const CrmEtablissement_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur CrmEtablissement_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.CrmEtablissement.create = async (model) => {
    return await CrmEtablissement_fetch('/models/CrmEtablissement', {
        method: 'POST',
        body: model
    });
};

sdk.models.CrmEtablissement.getAll = async () => {
    return await CrmEtablissement_fetch('/models/CrmEtablissement');
};

sdk.models.CrmEtablissement.getOne = async (id) => {
    const cacheKey = "CrmEtablissement_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await CrmEtablissement_fetch('/models/CrmEtablissement/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.CrmEtablissement.update = async (id, model) => {
    localStorage.removeItem("CrmEtablissement_one_" + id);
    return await CrmEtablissement_fetch('/models/CrmEtablissement/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.CrmEtablissement.delete = async (id) => {
    return await CrmEtablissement_fetch('/models/CrmEtablissement/' + id, {
        method: 'DELETE'
    });
};

sdk.models.CrmEtablissement.search = async (data) => {
    return await CrmEtablissement_fetch('/models/CrmEtablissement/search', {
        method: 'POST',
        body: data
    });
};

sdk.models.CrmEtablissement.onUpdate = async (data) => {
    return await CrmEtablissement_fetch('/models/CrmEtablissement/onUpdate', {
        method: 'POST',
        body: data
    });
};
sdk.models.audit_sessions = {};

const audit_sessions_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur audit_sessions_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.audit_sessions.create = async (model) => {
    return await audit_sessions_fetch('/models/audit_sessions', {
        method: 'POST',
        body: model
    });
};

sdk.models.audit_sessions.getAll = async () => {
    return await audit_sessions_fetch('/models/audit_sessions');
};

sdk.models.audit_sessions.getOne = async (id) => {
    const cacheKey = "audit_sessions_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await audit_sessions_fetch('/models/audit_sessions/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.audit_sessions.update = async (id, model) => {
    localStorage.removeItem("audit_sessions_one_" + id);
    return await audit_sessions_fetch('/models/audit_sessions/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.audit_sessions.delete = async (id) => {
    return await audit_sessions_fetch('/models/audit_sessions/' + id, {
        method: 'DELETE'
    });
};

sdk.models.audit_sessions.create = async (data) => {
    return await audit_sessions_fetch('/models/audit_sessions/create', {
        method: 'POST',
        body: data
    });
};
sdk.models.audit_page_views = {};

const audit_page_views_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur audit_page_views_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.audit_page_views.create = async (model) => {
    return await audit_page_views_fetch('/models/audit_page_views', {
        method: 'POST',
        body: model
    });
};

sdk.models.audit_page_views.getAll = async () => {
    return await audit_page_views_fetch('/models/audit_page_views');
};

sdk.models.audit_page_views.getOne = async (id) => {
    const cacheKey = "audit_page_views_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await audit_page_views_fetch('/models/audit_page_views/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.audit_page_views.update = async (id, model) => {
    localStorage.removeItem("audit_page_views_one_" + id);
    return await audit_page_views_fetch('/models/audit_page_views/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.audit_page_views.delete = async (id) => {
    return await audit_page_views_fetch('/models/audit_page_views/' + id, {
        method: 'DELETE'
    });
};

sdk.models.audit_page_views.create = async (data) => {
    return await audit_page_views_fetch('/models/audit_page_views/create', {
        method: 'POST',
        body: data
    });
};
sdk.models.audit_user_interactions = {};

const audit_user_interactions_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur audit_user_interactions_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.audit_user_interactions.create = async (model) => {
    return await audit_user_interactions_fetch('/models/audit_user_interactions', {
        method: 'POST',
        body: model
    });
};

sdk.models.audit_user_interactions.getAll = async () => {
    return await audit_user_interactions_fetch('/models/audit_user_interactions');
};

sdk.models.audit_user_interactions.getOne = async (id) => {
    const cacheKey = "audit_user_interactions_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await audit_user_interactions_fetch('/models/audit_user_interactions/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.audit_user_interactions.update = async (id, model) => {
    localStorage.removeItem("audit_user_interactions_one_" + id);
    return await audit_user_interactions_fetch('/models/audit_user_interactions/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.audit_user_interactions.delete = async (id) => {
    return await audit_user_interactions_fetch('/models/audit_user_interactions/' + id, {
        method: 'DELETE'
    });
};

sdk.models.audit_user_interactions.create = async (data) => {
    return await audit_user_interactions_fetch('/models/audit_user_interactions/create', {
        method: 'POST',
        body: data
    });
};
sdk.models.CrmFollowup = {};

const CrmFollowup_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur CrmFollowup_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.CrmFollowup.create = async (model) => {
    return await CrmFollowup_fetch('/models/CrmFollowup', {
        method: 'POST',
        body: model
    });
};

sdk.models.CrmFollowup.getAll = async () => {
    return await CrmFollowup_fetch('/models/CrmFollowup');
};

sdk.models.CrmFollowup.getOne = async (id) => {
    const cacheKey = "CrmFollowup_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await CrmFollowup_fetch('/models/CrmFollowup/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.CrmFollowup.update = async (id, model) => {
    localStorage.removeItem("CrmFollowup_one_" + id);
    return await CrmFollowup_fetch('/models/CrmFollowup/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.CrmFollowup.delete = async (id) => {
    return await CrmFollowup_fetch('/models/CrmFollowup/' + id, {
        method: 'DELETE'
    });
};

sdk.models.CrmFollowup.timer = async (data) => {
    return await CrmFollowup_fetch('/models/CrmFollowup/timer', {
        method: 'POST',
        body: data
    });
};
sdk.models.TaskReview = {};

const TaskReview_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur TaskReview_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.TaskReview.create = async (model) => {
    return await TaskReview_fetch('/models/TaskReview', {
        method: 'POST',
        body: model
    });
};

sdk.models.TaskReview.getAll = async () => {
    return await TaskReview_fetch('/models/TaskReview');
};

sdk.models.TaskReview.getOne = async (id) => {
    const cacheKey = "TaskReview_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await TaskReview_fetch('/models/TaskReview/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.TaskReview.update = async (id, model) => {
    localStorage.removeItem("TaskReview_one_" + id);
    return await TaskReview_fetch('/models/TaskReview/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.TaskReview.delete = async (id) => {
    return await TaskReview_fetch('/models/TaskReview/' + id, {
        method: 'DELETE'
    });
};

sdk.models.TaskReview.onCreate = async (data) => {
    return await TaskReview_fetch('/models/TaskReview/onCreate', {
        method: 'POST',
        body: data
    });
};

sdk.models.TaskReview.getRated = async (data) => {
    return await TaskReview_fetch('/models/TaskReview/getRated', {
        method: 'POST',
        body: data
    });
};
sdk.models.AdBidRequest = {};

const AdBidRequest_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur AdBidRequest_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.AdBidRequest.create = async (model) => {
    return await AdBidRequest_fetch('/models/AdBidRequest', {
        method: 'POST',
        body: model
    });
};

sdk.models.AdBidRequest.getAll = async () => {
    return await AdBidRequest_fetch('/models/AdBidRequest');
};

sdk.models.AdBidRequest.getOne = async (id) => {
    const cacheKey = "AdBidRequest_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await AdBidRequest_fetch('/models/AdBidRequest/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.AdBidRequest.update = async (id, model) => {
    localStorage.removeItem("AdBidRequest_one_" + id);
    return await AdBidRequest_fetch('/models/AdBidRequest/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.AdBidRequest.delete = async (id) => {
    return await AdBidRequest_fetch('/models/AdBidRequest/' + id, {
        method: 'DELETE'
    });
};

sdk.models.AdBidRequest.initModel = async (data) => {
    return await AdBidRequest_fetch('/models/AdBidRequest/initModel', {
        method: 'POST',
        body: data
    });
};

sdk.models.AdBidRequest.request = async (data) => {
    return await AdBidRequest_fetch('/models/AdBidRequest/request', {
        method: 'POST',
        body: data
    });
};

sdk.models.AdBidRequest.winBid = async (data) => {
    return await AdBidRequest_fetch('/models/AdBidRequest/winBid', {
        method: 'POST',
        body: data
    });
};
sdk.models.RtbImpression = {};

const RtbImpression_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur RtbImpression_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.RtbImpression.create = async (model) => {
    return await RtbImpression_fetch('/models/RtbImpression', {
        method: 'POST',
        body: model
    });
};

sdk.models.RtbImpression.getAll = async () => {
    return await RtbImpression_fetch('/models/RtbImpression');
};

sdk.models.RtbImpression.getOne = async (id) => {
    const cacheKey = "RtbImpression_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await RtbImpression_fetch('/models/RtbImpression/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.RtbImpression.update = async (id, model) => {
    localStorage.removeItem("RtbImpression_one_" + id);
    return await RtbImpression_fetch('/models/RtbImpression/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.RtbImpression.delete = async (id) => {
    return await RtbImpression_fetch('/models/RtbImpression/' + id, {
        method: 'DELETE'
    });
};

sdk.models.RtbImpression.addImp = async (data) => {
    return await RtbImpression_fetch('/models/RtbImpression/addImp', {
        method: 'POST',
        body: data
    });
};
sdk.models.PostsWaiting = {};

const PostsWaiting_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur PostsWaiting_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.PostsWaiting.create = async (model) => {
    return await PostsWaiting_fetch('/models/PostsWaiting', {
        method: 'POST',
        body: model
    });
};

sdk.models.PostsWaiting.getAll = async () => {
    return await PostsWaiting_fetch('/models/PostsWaiting');
};

sdk.models.PostsWaiting.getOne = async (id) => {
    const cacheKey = "PostsWaiting_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await PostsWaiting_fetch('/models/PostsWaiting/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.PostsWaiting.update = async (id, model) => {
    localStorage.removeItem("PostsWaiting_one_" + id);
    return await PostsWaiting_fetch('/models/PostsWaiting/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.PostsWaiting.delete = async (id) => {
    return await PostsWaiting_fetch('/models/PostsWaiting/' + id, {
        method: 'DELETE'
    });
};

sdk.models.PostsWaiting.timer = async (data) => {
    return await PostsWaiting_fetch('/models/PostsWaiting/timer', {
        method: 'POST',
        body: data
    });
};
sdk.models.Jeton = {};

const Jeton_fetch = async (endpoint, options = {}) => {
    try {
        // Initialiser la connexion si pas encore fait
        if (!wsManager) {
            console.log('Initialisation WebSocket...');
            await initWebSocket(false);
        }
        
        // Si la connexion existe mais n'est pas connectée, attendre ou reconnecter
        if (wsManager && !wsManager.connected) {
            console.log('WebSocket déconnecté, tentative de reconnexion...');
            const maxWaitTime = 15000; // 15 secondes max
            const startTime = Date.now();
            
            // Attendre que la reconnexion automatique se fasse
            while (!wsManager.connected && (Date.now() - startTime) < maxWaitTime) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            // Si toujours pas connecté, essayer de forcer la reconnexion
            if (!wsManager.connected) {
                const hostname = false ? 'devapi.liberium.net' : 'api.liberium.net';
                await wsManager.connect('wss://api.liberium.net/ws', hostname);
            }
        }
        
        const token = localStorage.getItem("liberium-token");
        const response = await wsManager.sendRequest(
            options.method || 'GET',
            endpoint,
            {
                body: options.body,
                headers: options.headers || {},
                token: token
            }
        );
        
        if (response.status >= 400) {
            return { error: response.data || 'Erreur serveur' };
        }
        
        return response.data;
    } catch (error) {
        console.error('Erreur Jeton_fetch:', error);
        return { error: error.message };
    }
};

sdk.models.Jeton.create = async (model) => {
    return await Jeton_fetch('/models/Jeton', {
        method: 'POST',
        body: model
    });
};

sdk.models.Jeton.getAll = async () => {
    return await Jeton_fetch('/models/Jeton');
};

sdk.models.Jeton.getOne = async (id) => {
    const cacheKey = "Jeton_one_" + id;
    let cache = localStorage.getItem(cacheKey);
    if (cache) {
        cache = JSON.parse(cache);
        if (cache.ttl && cache.ttl >= Date.now()) {
            return cache;
        }
    }
    
    const result = await Jeton_fetch('/models/Jeton/' + id);
    if (!result.error) {
        result.ttl = Date.now() + 2400000;
        localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return result;
};

sdk.models.Jeton.update = async (id, model) => {
    localStorage.removeItem("Jeton_one_" + id);
    return await Jeton_fetch('/models/Jeton/' + id, {
        method: 'PUT',
        body: model
    });
};

sdk.models.Jeton.delete = async (id) => {
    return await Jeton_fetch('/models/Jeton/' + id, {
        method: 'DELETE'
    });
};
export {sdk};
